import React, { useState, useCallback, useEffect } from "react";
import { createPortal } from "react-dom";
import { useRef } from "react";
import { axiosPostApi, axiosGetApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import axios from "axios";
import { FaTrash } from "react-icons/fa";
import styles from "../../css/CreateOrder.module.css";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import EmailIcon from "@mui/icons-material/Email";
import BusinessIcon from "@mui/icons-material/Business";
import PinCodeIcon from "@mui/icons-material/PushPin";
import StateIcon from "@mui/icons-material/Flag";
import PublicIcon from "@mui/icons-material/Public";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import RupeeIcon from "@mui/icons-material/CurrencyRupee";
import TagIcon from "@mui/icons-material/Tag";
import ShippingIcon from "@mui/icons-material/LocalShipping";
import { FaBalanceScale } from "react-icons/fa";
import StraightenIcon from "@mui/icons-material/Straighten";
import { RxDimensions } from "react-icons/rx";
import { FaProductHunt } from "react-icons/fa6";
import { MdProductionQuantityLimits } from "react-icons/md";
import { FaList } from "react-icons/fa";
import { IoMdPaper } from "react-icons/io";
import { TbFileDescription } from "react-icons/tb";
import AddPickupAddressModal from "../pickupaddress/AddPickupAddressModal";
import ChargesConfirmationModal from "./ChargesConfirmationModal";
import AddVectorIcon from "../../../src/assets/Icons/Add Vector.png";
import CancelOrderModal from "./CancelOrderModal";
import { useSelector } from "react-redux";
const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};
const CreateOrderModal = ({
  show,
  handleClose,
  refreshTable,
  editData,
  action,
  columnData,
  onSuccess, // New prop for handling success (opening receipt)
}) => {
  const courierServiceKey = sessionStorage.getItem("courierServiceKey");
  const loggedInUserName = sessionStorage.getItem("username");
  const dashboardData = useSelector((state) => state.balance.balance);

  const lastFetchedConsigneePinRef = useRef("");
  const lastFetchedConsignorPinRef = useRef("");

  const [carrierOptions, setCarrierOptions] = useState([]);
  const [form, setForm] = useState({
    // Consignee
    consigneeName: "",
    consigneeMobile: "",
    consigneePhone: "",
    consigneeEmailId: "",
    consigneeAddress1: "",
    consigneePincode: "",
    consigneeCity: "",
    consigneeState: "",
    consigneeCountry: "",
    // Consignor
    consignorName: "",
    consignorMobile: "",
    consignorPhone: "",
    consignorEmailId: "",
    consignorAddress1: "",
    consignorPincode: "",
    consignorCity: "",
    consignorState: "",
    consignorCountry: "",
    paymentMode: "",
    expressType: "",
    isNdd: "0",
    orderAmount: "",
    codAmount: "",
    invoiceNumber: "",
    shipmentWeight: "",
    shipmentLength: "",
    shipmentWidth: "",
    shipmentHeight: "",
    shipmentType: "",
    pickAddressId: "",
    returnAddressId: "",
    ourWaybillNumber: "",
    ewaybillNumber: "",
    useConsignorForPickup: false,
    useConsignorForReturn: false,
    govtApprovedGoods: false,
  });
  const [products, setProducts] = useState([
    {
      productName: "",
      productQuantity: "",
      productValue: "",
      productCategory: "",
      productDescription: "",
      productSku: "",
      productHsnsac: "",
      productTaxper: "",
    },
  ]);
  const [errors, setErrors] = useState({});
  const [productErrors, setProductErrors] = useState([{}]);
  const [loading, setLoading] = useState(false);
  const [pincodeLoading, setPincodeLoading] = useState(false);
  const [addressDetails, setAddressDetails] = useState([]);
  const [loadingAddresses, setLoadingAddresses] = useState(false);
  const [pincodeCheck, setPincodeCheck] = useState(false);
  const [sections, setSections] = useState({
    consigneeDetails: false,
    consignorDetails: false,
    orderDetails: false,
    shipmentDetails: false,
  });
  const [showChargesModal, setShowChargesModal] = useState(false);
  const [chargesData, setChargesData] = useState(null);
  const [chargesLoading, setChargesLoading] = useState(false);
  const [chargesError, setChargesError] = useState(null);
  const [showCustomAddressModal, setShowCustomAddressModal] = useState(false);
  const [modalColumnData, setModalColumnData] = useState({});
  const [expectNewAddress, setExpectNewAddress] = useState(false);
  const [previousAddressLength, setPreviousAddressLength] = useState(0);
  const [showCancelModal, setShowCancelModal] = useState(false);

  // COD charges: If codAmount is greater than 2000, COD charges are 1.5% of codAmount, else flat 30
  const codCharges =
    form?.paymentMode === "COD"
      ? parseFloat(form?.codAmount) > 2000
        ? parseFloat(form?.codAmount) * 0.015
        : 30
      : 0;

  useEffect(() => {
    if (
      action === "modify" ||
      action === "view" ||
      action === "delete" ||
      action === "cancelOrder"
    ) {
      setForm({
        ...editData,
        consigneeName: columnData?.consigneeName || "",
        consigneeMobile: columnData?.consigneeMobile || "",
        consigneePhone: columnData?.consigneePhone || "",
        consigneeEmailId: columnData?.consigneeEmailId || "",
        consigneeAddress1: columnData?.consigneeAddress1 || "",
        consigneePincode: columnData?.consigneePincode || "",
        consigneeCity: columnData?.consigneeCity || "",
        consigneeState: columnData?.consigneeState || "",
        consigneeCountry: columnData?.consigneeCountry || "",
        paymentMode: columnData?.paymentMode || "",
        expressType: columnData?.expressType || "",
        isNdd: columnData?.isNdd || "0",
        orderAmount: columnData?.orderAmountE || "",
        codAmount: columnData?.codAmountE || "",
        invoiceNumber: columnData?.invoiceNumber || "",
        shipmentWeight: columnData?.shipmentWeight || "",
        shipmentLength: columnData?.shipmentLength
          ? parseFloat(columnData.shipmentLength).toFixed(2)
          : "",
        shipmentWidth: columnData?.shipmentWidth
          ? parseFloat(columnData.shipmentWidth).toFixed(2)
          : "",
        shipmentHeight: columnData?.shipmentHeight
          ? parseFloat(columnData.shipmentHeight).toFixed(2)
          : "",
        shipmentType: columnData?.shipmentType || "",
        pickAddressId: columnData?.pickAddressId || "",
        returnAddressId: columnData?.returnAddressId || "",
        ourWaybillNumber: columnData?.ourWaybillNumber || "",
        ewaybillNumber: columnData?.ewaybillNumber || "",
        useConsignorForPickup: columnData?.useConsignorForPickup || false,
        useConsignorForReturn: columnData?.useConsignorForReturn || false,
      });
      if (Array.isArray(columnData?.products)) {
        setProducts(columnData.products);
        setProductErrors(new Array(columnData.products.length).fill({}));
        setSections((prev) => ({
          ...prev,
          productSections: new Array(columnData.products.length).fill(false),
        }));
      }
      if (columnData?.consigneePincode) {
        setPincodeCheck(true);
      }
      fetchAddressDetails();
    }
  }, [action, columnData]);

  const fetchPincodeDetails = useCallback(
    debounce(async (pincode, type = "consignee") => {
      if (
        type === "consignee" &&
        pincode === lastFetchedConsigneePinRef.current
      )
        return;
      if (
        type === "consignor" &&
        pincode === lastFetchedConsignorPinRef.current
      )
        return;
      if (type === "consignee") lastFetchedConsigneePinRef.current = pincode;
      if (type === "consignor") lastFetchedConsignorPinRef.current = pincode;
      const cityKey = `${type}City`;
      const stateKey = `${type}State`;
      const countryKey = `${type}Country`;
      const pincodeKey = `${type}Pincode`;
      if (!pincode) {
        setForm((prev) => ({
          ...prev,
          [cityKey]: "",
          [stateKey]: "",
          [countryKey]: "",
        }));
        return;
      }
      setPincodeLoading(true);
      if (type === "consignee") setPincodeCheck(false);
      try {
        const response = await axios.get(`${apiList.PINCODE_DATA}/${pincode}`);
        if (
          response?.data?.status === true &&
          response?.data?.respCode === "00"
        ) {
          const { cityName, state, country } = response?.data?.data[0];
          setForm((prev) => ({
            ...prev,
            [cityKey]: cityName || "",
            [stateKey]: state || "",
            [countryKey]: country || "",
          }));
        } else {
          setForm((prev) => ({
            ...prev,
            [cityKey]: "",
            [stateKey]: "",
            [countryKey]: "",
          }));
        }
      } catch (err) {
        console.error("Pincode fetch error:", err);
      } finally {
        setPincodeLoading(false);
      }
    }, 500),
    [],
  );

  const validateField = (name, value, formContext = form) => {
    value = value !== null && value !== undefined ? String(value) : "";

    if (name === "ourWaybillNumber") {
      const trimmed = value.trim();

      // 1. Required field validation
      if (!trimmed) {
        return "Our Waybill Number is required.";
      }

      // 2. Check if starts with BC
      if (!trimmed.startsWith("BC")) {
        return "Waybill Number must start with 'BC'";
      }

      return "";
    }

    switch (name) {
      case "consigneeName": {
        if (!value.trim()) return "Consignee name is required";
        if (value.length > 50)
          return "Consignee name must be at most 50 characters";
        if (!/^[A-Za-z\s]+$/.test(value))
          return "Only letters and spaces are allowed";
        return "";
      }

      case "consigneeMobile": {
        if (!value) return "Mobile number is required";
        // Must be 10 digits starting with 6-9
        if (!/^[6-9]\d{9}$/.test(value)) {
          return "Enter a valid 10-digit mobile number starting with 6-9";
        }
        // Prevent all digits being same (like 9999999999)
        if (/^(\d)\1{9}$/.test(value)) {
          return "Duplicate/repeated mobile numbers are not allowed";
        }
        return "";
      }
      case "consigneePhone":
        return value && !/^[6-9]\d{9}$/.test(value)
          ? "Enter a valid 10-digit phone number"
          : "";
      case "consigneeEmailId": {
        const trimmed = value.trim().toLowerCase();
        if (!trimmed) return "Email ID is required";
        // 🚫 Prevent consecutive dots or trailing dot
        if (/\.\./.test(trimmed) || trimmed.endsWith(".")) {
          return "Email cannot contain consecutive dots or end with a dot";
        }
        // 🚫 Prevent repeated domain fragments (.comgmail.com, .com.com, etc.)
        if (
          trimmed.includes("gmail.comgmail.") ||
          trimmed.includes("comgmail.") ||
          trimmed.includes("in.in") ||
          trimmed.includes("com.com") ||
          trimmed.includes("net.net") ||
          trimmed.includes("org.org") ||
          trimmed.includes("co.in.co.in") ||
          trimmed.includes("pe.pe")
        ) {
          return "Email cannot contain repeated domain parts like .comgmail.com or .com.com";
        }
        // ✅ Strict email format (must end properly with one of these domains)
        const emailRegex =
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|in|co\.in|net|org|pe)$/i;
        if (!emailRegex.test(trimmed)) {
          return "Enter a valid email ending with .com, .in, .co.in, .net, .org, or .pe";
        }
        return "";
      }
      case "consigneeAddress1":
        if (!value.trim()) return "Address is required";
        if (value.trim().length < 20)
          return "Address must be at least 20 characters";
        return "";
      case "consigneePincode":
        if (!/^[1-9][0-9]{5}$/.test(value))
          return "Enter a valid 6-digit pincode";
        return "";
      case "consigneeCity":
        return value.trim() ? "" : "City is required";
      case "consigneeState":
        return value.trim() ? "" : "State is required";
      case "consigneeCountry":
        return value.trim() ? "" : "Country is required";
      // ---------------- CONSIGNOR VALIDATION ----------------
      case "consignorName": {
        if (!value.trim()) return "Consignor name is required";
        if (value.length > 50)
          return "Consignor name must be at most 50 characters";
        if (!/^[A-Za-z\s]+$/.test(value))
          return "Only letters and spaces are allowed";
        return "";
      }

      case "consignorMobile": {
        if (!value) return "Consignor mobile number is required";
        if (!/^[6-9]\d{9}$/.test(value))
          return "Enter a valid 10-digit mobile number starting with 6-9";
        if (/^(\d)\1{9}$/.test(value))
          return "Duplicate/repeated mobile numbers are not allowed";
        return "";
      }
      case "consignorPhone":
        return value && !/^[6-9]\d{9}$/.test(value)
          ? "Enter a valid 10-digit phone number"
          : "";
      case "consignorEmailId": {
        const trimmed = value.trim().toLowerCase();
        if (!trimmed) return "Consignor email ID is required";
        if (/\.\./.test(trimmed) || trimmed.endsWith("."))
          return "Email cannot contain consecutive dots or end with a dot";
        if (
          trimmed.includes("gmail.comgmail.") ||
          trimmed.includes("comgmail.") ||
          trimmed.includes("com.com") ||
          trimmed.includes("net.net") ||
          trimmed.includes("org.org") ||
          trimmed.includes("co.in.co.in")
        )
          return "Email cannot contain repeated domain parts like .comgmail.com";
        const emailRegex =
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|in|co\.in|net|org|pe)$/i;
        if (!emailRegex.test(trimmed))
          return "Enter a valid email ending with .com, .in, .co.in, .net, .org, or .pe";
        return "";
      }
      case "consignorAddress1":
        return value.trim()
          ? value.trim().length < 20
            ? "Consignor address must be at least 20 characters"
            : ""
          : "Consignor address is required";
      case "consignorPincode":
        if (!/^[1-9][0-9]{5}$/.test(value))
          return "Enter a valid 6-digit consignor pincode";
        return "";
      case "consignorCity":
        return value.trim() ? "" : "Consignor city is required";
      case "consignorState":
        return value.trim() ? "" : "Consignor state is required";
      case "consignorCountry":
        return value.trim() ? "" : "Consignor country is required";
      case "paymentMode":
        return value ? "" : "Payment mode is required";
      case "shipmentType":
        return value ? "" : "Shipment type is required";
      case "expressType":
        return value ? "" : "Express type is required";
      case "orderAmount":
        const amount = parseFloat(value);
        if (!value || isNaN(amount)) return "Order amount is required";
        if (amount <= 0) {
          if (form.paymentMode === "COD") {
            return "For Cash on Delivery, Order Amount must be greater than 0";
          }
          if (form.paymentMode === "PPD") {
            return "For PPD, Order Amount must be greater than 0";
          }
        }
        return "";
      case "codAmount": {
        const trimmed = value?.trim();
        if (formContext.paymentMode === "COD") {
          if (!trimmed) return "COD Amount is required";
          if (!/^\d+(\.\d{1,2})?$/.test(trimmed)) {
            return "Enter a valid COD amount (e.g., 100.00)";
          }
          if (parseFloat(trimmed) <= 0) {
            return "COD Amount must be greater than 0";
          }
        }
        // For PPD mode or empty COD field — no error
        return "";
      }
      case "shipmentWeight": {
        const trimmed = value?.trim();
        if (!trimmed) return "Shipment weight is required";
        if (!/^\d+(\.\d{1,2})?$/.test(trimmed)) {
          return "Enter a valid weight (e.g., 1.50)";
        }
        if (parseFloat(trimmed) <= 0) {
          return "Weight must be greater than 0";
        }
        const numericWidth = parseFloat(trimmed);
        if (numericWidth < 0.1)
          return "Shipment weight must be minimum 0.1 or greater.";
        return "";
      }
      case "shipmentLength": {
        const trimmed = value?.trim();
        if (!trimmed) return "Shipment length is required";
        // Validate format like 10.00, 123.45
        if (!/^\d+(\.\d{1,2})?$/.test(trimmed))
          return "Enter a valid shipment length (e.g., 10.00)";
        // Prevent excessive total length (e.g., 999999, 9999.99 etc.)
        if (trimmed.length > 6)
          return "Shipment length must be at most 6 characters";
        // Prevent repeated digits like 111.00 or 222.22
        if (/^(\d)\1+(\.\d{1,2})?$/.test(trimmed))
          return "Repeated digits not allowed (e.g., 111.00)";
        return "";
      }
      case "shipmentWidth": {
        const trimmed = value?.trim();
        if (!trimmed) return "Shipment width is required";
        if (!/^\d+(\.\d{1,2})?$/.test(trimmed))
          return "Enter a valid width (e.g., 10.00)";
        if (trimmed.length > 10) return "Shipment width is too long";
        if (/^(\d)\1+(\.\d{1,2})?$/.test(trimmed))
          return "Repeated digits not allowed (e.g., 111.00)";
        return "";
      }
      case "shipmentHeight": {
        const trimmed = value?.trim();
        if (!trimmed) return "Shipment height is required";
        if (!/^\d+(\.\d{1,2})?$/.test(trimmed))
          return "Enter a valid height (e.g., 10.00)";
        if (trimmed.length > 10) return "Shipment height is too long";
        if (/^(\d)\1+(\.\d{1,2})?$/.test(trimmed))
          return "Repeated digits not allowed (e.g., 111.00)";
        return "";
      }
      case "invoiceNumber": {
        const trimmed = value?.trim();
        // if (!trimmed) return "Invoice Number is required";
        if (trimmed.length > 20)
          return "Invoice Number must be at most 20 characters";
        if (trimmed && !/^[a-zA-Z0-9\s\-\/]+$/.test(trimmed))
          return "Only letters, numbers, spaces, hyphens, and slashes allowed";
        return "";
      }
      case "pickAddressId": {
        if (form?.useConsignorForPickup) return "";
        const trimmed = value?.trim();
        if (!trimmed) return "Pick address ID is required";
        if (!/^\d+$/.test(trimmed)) return "Only digits are allowed";
        if (trimmed.length > 6)
          return "Pick address ID must be at most 6 digits";
        return "";
      }
      case "returnAddressId": {
        if (form?.useConsignorForReturn) return "";
        const trimmed = value?.trim();
        if (!trimmed) return "Return address ID is required";
        if (!/^\d+$/.test(trimmed)) return "Only digits are allowed";
        if (trimmed.length > 6)
          return "Return address ID must be at most 6 digits";
        return "";
      }
      case "govtApprovedGoods": {
        return value == "true"
          ? ""
          : "You must confirm that the goods comply with government regulations";
      }
      default:
        return "";
    }
  };
  const validateProductField = (name, value) => {
    value = value !== null && value !== undefined ? String(value) : "";
    switch (name) {
      case "productName": {
        const trimmed = value?.trim();
        if (!trimmed) return "Product name is required";
        if (trimmed.length > 50)
          return "Product name must be at most 50 characters";
        if (!/^[a-zA-Z0-9\s\-().]+$/.test(trimmed))
          return "Only letters, numbers, spaces, hyphens, dots, and parentheses allowed";
        return "";
      }
      case "productQuantity": {
        if (!value?.trim()) return "Product Quantity is required";
        if (!/^\d+$/.test(value.trim()))
          return "Enter a valid quantity (positive integer)";
        return "";
      }
      case "productValue":
        return value && /^\d+(\.\d{1,2})?$/.test(value)
          ? ""
          : "Enter a valid value (e.g., 100.00)";
      case "productCategory": {
        if (!value?.trim()) return "Product Category is required";
        const trimmed = value.trim();
        // ✅ Allow only letters, numbers, underscores, dashes, and spaces
        if (!/^[A-Za-z0-9_-]+$/.test(trimmed)) {
          return "The Product Category field may only contain alphanumeric characters, underscores and dashes";
        }
        if (trimmed.length < 5 || trimmed.length > 20) {
          return "Product Category must be between 5 and 20 characters";
        }
        // ✅ Prevents repeated same character 5 or more times (like 'aaaaa' or '11111')
        if (/([A-Za-z0-9_-])\1{4,}/.test(trimmed)) {
          return "Repeated characters are not allowed";
        }
        return "";
      }
      case "productDescription": {
        const trimmed = value?.trim();
        // if (!trimmed) {
        //   return "Description is required";
        // }
        if (trimmed.length > 100) {
          return "Description must be at most 100 characters";
        }
        return "";
      }
      case "productSku": {
        const trimmed = value?.trim();
        // if (!trimmed) return "Product SKU is required";
        if (trimmed && !/^[a-zA-Z0-9_-]{3,30}$/.test(trimmed)) {
          return "SKU must be 3–30 characters: letters, numbers, _ or - only";
        }
        return "";
      }
      case "productHsnsac": {
        const trimmed = value?.trim();
        // if (!trimmed) return "Product HSNSAC is required";
        if (trimmed && !/^\d{4,8}$/.test(trimmed)) {
          return "HSNSAC must be a 4–8 digit number (no letters or symbols)";
        }
        return "";
      }
      case "productTaxper": {
        if (!value) return ""; // ✅ optional

        if (!/^\d+(\.\d{1,2})?$/.test(value))
          return "Enter valid tax % (e.g., 5.0)";

        return "";
      }
    }
  };
  const handleBlur = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;
    if (["orderAmount", "codAmount"].includes(name)) {
      const floatVal = parseFloat(value);
      if (!isNaN(floatVal)) {
        formattedValue = floatVal.toFixed(2);
      }
    }
    setForm((prev) => ({
      ...prev,
      [name]: formattedValue,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: validateField(name, formattedValue, {
        ...form,
        [name]: formattedValue,
      }),
    }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    // PAYMENT MODE LOGIC
    if (name === "paymentMode") {
      const updatedForm = {
        ...form,
        paymentMode: value,
      };

      if (value === "PPD") {
        updatedForm.codAmount = "";
      } else if (value === "COD") {
        updatedForm.orderAmount = "";
      } else if (value === "") {
        updatedForm.orderAmount = "";
        updatedForm.codAmount = "";
      }

      setForm(updatedForm);
      setErrors((prev) => ({
        ...prev,
        paymentMode: validateField("paymentMode", value),
      }));
      return;
    }

    // EXPRESS TYPE LOGIC
    if (name === "expressType") {
      let options = [];

      if (value === "air") {
        options = [
          { label: "Bluedart", value: "54" },
          { label: "Delhivery", value: "12" },
        ];
      } else if (value === "surface") {
        options = [
          { label: "Bluedart", value: "27" },
          { label: "Delhivery", value: "63" },
        ];
      }

      setCarrierOptions(options);
      setForm((prev) => ({ ...prev, expressType: value }));

      setErrors((prev) => ({
        ...prev,
        expressType: validateField("expressType", value),
      }));

      value ? fetchAddressDetails() : setAddressDetails([]);
      return;
    }

    // ORDER AMOUNT
    if (name === "orderAmount") {
      if (value === "" || /^\d*\.?\d*$/.test(value)) {
        const updatedForm = { ...form, orderAmount: value };

        // If orderAmount is being changed and it's >= 50000, set ewaybillNumber from ourWaybillNumber
        if (parseFloat(value || 0) >= 50000 && form.ourWaybillNumber) {
          updatedForm.ewaybillNumber = form.ourWaybillNumber;
        }

        // If orderAmount is being changed and it's < 50000, clear ewaybillNumber
        if (parseFloat(value || 0) < 50000) {
          updatedForm.ewaybillNumber = "";
        }

        setForm(updatedForm);
      }

      setErrors((prev) => ({
        ...prev,
        orderAmount: validateField("orderAmount", value),
      }));
      return;
    }

    // DEFAULT FIELD HANDLING
    setForm((prev) => {
      const updatedForm = { ...prev, [name]: value };

      // If Consignee Pincode changes → reset Payment Mode
      if (name === "consigneePincode") {
        updatedForm.paymentMode = "";
        updatedForm.orderAmount = "";
        updatedForm.codAmount = "";
        setPincodeCheck(false); // optional but recommended
        setErrors((prev) => ({
          ...prev,
          orderAmount: "",
        }));
      }

      // If ourWaybillNumber is being changed and orderAmount >= 50000, update ewaybillNumber
      if (
        name === "ourWaybillNumber" &&
        parseFloat(prev.orderAmount || 0) >= 50000
      ) {
        updatedForm.ewaybillNumber = value;
      }

      return updatedForm;
    });

    setErrors((prev) => ({
      ...prev,
      [name]: validateField(name, value, { ...form, [name]: value }),
    }));

    if (name === "consigneePincode" && value?.length >= 6)
      fetchPincodeDetails(value);
    if (name === "consignorPincode" && value?.length === 6)
      fetchPincodeDetails(value, "consignor");
  };

  const handleProductChange = (index, e) => {
    const { name, value } = e.target;
    const updatedProducts = [...products];
    updatedProducts[index][name] = value;
    setProducts(updatedProducts);
    const updatedProductErrors = [...productErrors];
    updatedProductErrors[index] = {
      ...updatedProductErrors[index],
      [name]: validateProductField(name, value),
    };
    setProductErrors(updatedProductErrors);
  };
  const handleProductBlur = (index, e) => {
    const { name, value } = e.target;
    const updatedProducts = [...products];
    let formattedValue = value?.trim();
    const isRepeated = /^(\d)\1{4,}(\.\d{1,2})?$/.test(formattedValue);
    const isTooLong = formattedValue.length > 12; // Optional: limit extreme lengths
    if (
      (name === "productValue" || name === "productTaxper") &&
      (isRepeated || isTooLong)
    ) {
      const updatedProductErrors = [...productErrors];
      updatedProductErrors[index] = {
        ...updatedProductErrors[index],
        [name]: "Invalid or repeated digits not allowed",
      };
      setProductErrors(updatedProductErrors);
      return;
    }
    if (name === "productValue") {
      const floatVal = parseFloat(formattedValue);
      if (!isNaN(floatVal)) {
        formattedValue = floatVal.toFixed(2);
      }
    }
    if (name === "productTaxper") {
      const floatVal = parseFloat(formattedValue);
      if (!isNaN(floatVal)) {
        formattedValue = floatVal.toFixed(1);
      }
    }
    updatedProducts[index][name] = formattedValue;
    setProducts(updatedProducts);
    const updatedProductErrors = [...productErrors];
    updatedProductErrors[index] = {
      ...updatedProductErrors[index],
      [name]: validateProductField(name, formattedValue),
    };
    setProductErrors(updatedProductErrors);
  };
  const addProduct = () => {
    setProducts([
      ...products,
      {
        productName: "",
        productQuantity: "",
        productValue: "",
        productCategory: "",
        productDescription: "",
        productSku: "",
        productHsnsac: "",
        productTaxper: "",
      },
    ]);
    setProductErrors([...productErrors, {}]);
    setSections((prev) => ({
      ...prev,
      productSections: [
        ...(prev.productSections || Array(products.length).fill(false)),
        false,
      ],
    }));
  };
  const removeProduct = (index) => {
    setProducts(products.filter((_, i) => i !== index));
    setProductErrors(productErrors.filter((_, i) => i !== index));
    setSections((prev) => {
      const newProductSections = prev.productSections
        ? [...prev.productSections]
        : [];
      newProductSections.splice(index, 1);
      return { ...prev, productSections: newProductSections };
    });
  };
  const validateForm = () => {
    const newErrors = {};
    Object.keys(form).forEach((key) => {
      newErrors[key] = validateField(key, form[key]);
    });
    const orderAmount = parseFloat(form.orderAmount || 0);
    const codAmount = parseFloat(form.codAmount || 0);
    if (form.paymentMode === "COD") {
      const codStr =
        form.codAmount !== null && form.codAmount !== undefined
          ? String(form.codAmount).trim()
          : "";
      if (codStr) {
        if (!/^\d+(\.\d{1,2})?$/.test(codStr)) {
          newErrors.codAmount = "Enter a valid COD amount (e.g., 100.00)";
        } else if (codAmount > orderAmount) {
          newErrors.codAmount = "COD Amount cannot exceed Order Amount";
        }
      } else {
        newErrors.codAmount = "COD Amount is required";
      }
    }
    const newProductErrors = products.map((product) => {
      const productError = {};
      Object.keys(product).forEach((key) => {
        productError[key] = validateProductField(key, product[key]);
      });
      return productError;
    });
    setErrors(newErrors);
    setProductErrors(newProductErrors);
    if (products.length === 0) {
      return "At least one product is required";
    }
    return Object.values(newErrors).some((error) => error) ||
      newProductErrors.some((prod) =>
        Object.values(prod).some((error) => error),
      )
      ? "Please correct the errors in the form"
      : null;
  };
  const selectedPickupAddress = addressDetails?.find(
    (addr) => addr.optnAddressId == form.pickAddressId,
  );
  const selectedReturnAddress = addressDetails?.find(
    (addr) => addr.optnAddressId == form.returnAddressId,
  );
  const handleSubmit = async () => {
    // 1) run same validations as before
    const validationError = validateForm();
    if (validationError) {
      CustomAlert({
        title: "Validation Error",
        text: validationError,
        icon: "error",
        confirmButtonText: "Okay",
        customClass: {
          container: "z-[99999]",
          popup: "z-[99999]",
        },
      });
      return;
    }

    // 2) courier key check unchanged
    if (!courierServiceKey) {
      CustomAlert({
        title: "Error",
        text: "No courier service key available. Please select a valid courier.",
        icon: "error",
        confirmButtonText: "Okay",
        customClass: {
          container: "z-[99999]",
          popup: "z-[99999]",
        },
      });
      return;
    }

    // 3) pincode check unchanged
    if (!pincodeCheck) {
      CustomAlert({
        title: "Warning",
        text: "Please verify the consignee pincode by clicking the 'Check' button before submitting.",
        icon: "warning",
        confirmButtonText: "Okay",
        customClass: {
          container: "z-[99999]",
          popup: "z-[99999]",
        },
      });
      return;
    }

    // 4) Prepare payload for CHECK_CHARGES (fields per your POSTMAN example)
    const checkChargesPayload = {
      username: loggedInUserName,
      sourcePincode: form?.consignorPincode || "", // source pincode (consignor)
      destinationPincode: form?.consigneePincode || "",
      expressType: form?.expressType || "", // ensure matches API expectations (SURFACE/AIR etc)
      weight: parseFloat(form?.shipmentWeight) || 0,
      length: parseFloat(form?.shipmentLength) || 0,
      width: parseFloat(form?.shipmentWidth) || 0,
      height: parseFloat(form?.shipmentHeight) || 0,
    };

    setChargesLoading(true);
    setChargesError(null);

    try {
      const headers = {
        courierkey: courierServiceKey,
        "Content-Type": "application/json",
      };

      // Pre-validate barcode ownership if entered or changed
      const isBarcodeChanged =
        action !== "modify" ||
        form?.ourWaybillNumber?.trim() !== columnData?.ourWaybillNumber?.trim();

      if (
        isBarcodeChanged &&
        form?.ourWaybillNumber &&
        form.ourWaybillNumber.trim()
      ) {
        try {
          const valRes = await axiosGetApi(
            `${apiList.VALIDATE_BARCODE}?barcode=${encodeURIComponent(
              form.ourWaybillNumber.trim()
            )}&username=${encodeURIComponent(loggedInUserName)}`,
            headers
          );
          if (valRes?.data && valRes.data.status === false) {
            setChargesLoading(false);
            CustomAlert({
              title: "Barcode Error",
              text: valRes.data.message || "Invalid or unassigned barcode.",
              icon: "error",
              confirmButtonText: "Okay",
              customClass: {
                container: "z-[99999]",
                popup: "z-[99999]",
              },
            });
            return;
          }
        } catch (valErr) {
          console.warn("Barcode pre-validation network warning:", valErr);
        }
      }

      // Call CHECK_CHARGES endpoint instead of creating the order immediately
      const checkResponse = await axiosPostApi(
        apiList.CHECK_CHARGES,
        checkChargesPayload,
        headers,
      );

      if (
        checkResponse?.data?.status === true &&
        checkResponse?.data?.respCode === "00"
      ) {
        // Expecting response.data.data with amount, walletBalance, gst, totalCharges, fuelCharges
        const cData = checkResponse.data.data || checkResponse.data;
        setChargesData(cData);
        setShowChargesModal(true); // opens the popup for user confirmation
      } else {
        // Show the error from API if available
        CustomAlert({
          title: "Failed",
          text:
            checkResponse?.data?.message ||
            "Failed to check charges. Please verify and try again.",
          icon: "error",
          confirmButtonText: "Okay",
          customClass: {
            container: "z-[99999]",
            popup: "z-[99999]",
          },
        });
      }
    } catch (error) {
      console.error("CHECK_CHARGES API error:", error);
      CustomAlert({
        title: "Error",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "An error occurred while checking charges. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
        customClass: {
          container: "z-[99999]",
          popup: "z-[99999]",
        },
      });
    } finally {
      setChargesLoading(false);
    }
  };

  // Helper: this performs the original CREATE_ORDER call (moved into a helper for clarity)
  const submitCreateOrder = async () => {
    setLoading(true);
    setChargesLoading(true); // keep submit button disabled while this runs

    // Build the same requestBody as earlier but add totalCharges from CHECK_CHARGES
    const requestBody = {
      ...(action === "modify" && { id: columnData?.id }),
      username: loggedInUserName,
      consigneeName: form?.consigneeName,
      consigneeMobile: form?.consigneeMobile,
      consigneePhone: form?.consigneePhone,
      consigneeEmailId: form?.consigneeEmailId,
      consigneeAddress1: form?.consigneeAddress1,
      consigneePincode: form?.consigneePincode,
      consigneeCity: form?.consigneeCity,
      consigneeState: form?.consigneeState,
      consigneeCountry: form?.consigneeCountry,
      consignorName: form?.consignorName,
      consignorMobile: form?.consignorMobile,
      consignorPhone: form?.consignorPhone,
      consignorEmailId: form?.consignorEmailId,
      consignorAddress1: form?.consignorAddress1,
      consignorPincode: form?.consignorPincode,
      consignorCity: form?.consignorCity,
      consignorState: form?.consignorState,
      consignorCountry: form?.consignorCountry,
      useConsignorForPickup: form?.useConsignorForPickup,
      useConsignorForReturn: form?.useConsignorForReturn,
      invoiceNumber: form?.invoiceNumber,
      paymentMode: form?.paymentMode,
      expressType: form?.expressType,
      isNdd: form?.isNdd === "0" ? false : true,
      orderAmount: isNaN(parseFloat(form?.orderAmount))
        ? 0
        : parseFloat(form?.orderAmount),
      codAmount:
        form?.paymentMode === "PPD" || !form?.codAmount
          ? 0
          : parseFloat(form?.codAmount),
      shipmentWeight: parseFloat(form?.shipmentWeight) || 0,
      shipmentLength: form?.shipmentLength
        ? parseFloat(form.shipmentLength).toFixed(2)
        : "0.00",
      shipmentWidth: form?.shipmentWidth
        ? parseFloat(form.shipmentWidth).toFixed(2)
        : "0.00",
      shipmentHeight: form?.shipmentHeight
        ? parseFloat(form.shipmentHeight).toFixed(2)
        : "0.00",
      shipmentType: form?.shipmentType,
      pickAddressId: Number(form?.pickAddressId) || 0,
      pickAddressCharId: addressDetails?.find(
        (addr) => addr.optnAddressId === form.pickAddressId,
      )?.addressId,
      returnAddressId: Number(form?.returnAddressId) || 0,
      returnAddressCharId: addressDetails?.find(
        (addr) => addr.optnAddressId === form.returnAddressId,
      )?.addressId,
      ourWaybillNumber: form.ourWaybillNumber.trim() || "",
      ewaybillNumber: form.ewaybillNumber.trim() || "",
      govtApprovedGoods: form.govtApprovedGoods ? true : false,
      products: products?.map((product) => ({
        id: product?.id,
        productName: product?.productName,
        productQuantity: Number(product?.productQuantity),
        productValue: parseFloat(product?.productValue || 0),
        productCategory: product?.productCategory,
        productDescription: product?.productDescription,
        productSku: product?.productSku,
        productHsnsac: product?.productHsnsac,
        productTaxper: parseFloat(product?.productTaxper || 0),
      })),
      // NEW FIELD: totalCharges (value taken from the CHECK_CHARGES response)
      totalCharges:
        (parseFloat(chargesData?.totalCharges) || 0) + (parseFloat(codCharges) || 0),
      baseAmount: chargesData?.baseAmount,
      fuelCharges: chargesData?.fuelCharges,
      gstPercent: chargesData?.gstPercent,
      gstAmount: chargesData?.gstAmount,
      codCharges: codCharges,
    };

    try {
      const headers = {
        courierkey: courierServiceKey,
        "Content-Type": "application/json",
      };

      const apiEndpoint =
        action === "modify" ? apiList.MODIFY_ORDER : apiList.CREATE_ORDER;
      const response = await axiosPostApi(apiEndpoint, requestBody, headers);

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        const bData = response.data?.data;
        const lmbpData = bData?.lmbpDetails || {};

        const orderId =
          response?.data?.data?.orderId ||
          response.data?.waybill ||
          "TEMP-ORDER-ID";
        const trackingNumber =
          response.data?.data?.trackingNumber || "TEMP-TRACKING";
        const receiptNumber = orderId;
        const receiptDate = new Date().toLocaleDateString("en-IN");
        const customerName = form.consignorName;
        const receiverAddress = `${form.consigneeAddress1}, ${form.consigneeCity}, ${form.consigneeState}, ${form.consigneeCountry}, ${form.consigneePincode}`;
        const selectedPickupAddresss = `${selectedPickupAddress?.fullAddress}, ${selectedPickupAddress?.city}, ${selectedPickupAddress?.state}, ${selectedPickupAddress?.pinCode}`;
        const consignorAddress = `${form.consignorAddress1}, ${form.consignorCity}, ${form.consignorState}, ${form.consignorCountry}, ${form.consignorPincode}`;
        const pickupAddress = form?.useConsignorForPickup
          ? consignorAddress
          : selectedPickupAddresss;
        const selectedRetuenAddresss = `${selectedReturnAddress?.fullAddress}, ${selectedReturnAddress?.city}, ${selectedReturnAddress?.state}, ${selectedReturnAddress?.pinCode}`;
        const returnAddress = form?.useConsignorForReturn
          ? consignorAddress
          : selectedRetuenAddresss;
        const customerAddress = consignorAddress;
        const customerContact = form.consignorMobile;
        const consigneeContact = form.consigneeMobile;
        const grandTotal = parseFloat(form.orderAmount || 0).toFixed(2);
        const paymentMode = form.paymentMode;
        const amountPaid =
          form.paymentMode === "COD"
            ? parseFloat(form.codAmount || 0).toFixed(2)
            : grandTotal;
        const balanceDue = "0.00";
        const pickupLocation = pickupAddress;
        const deliveryAddress = receiverAddress;
        const expectedDeliveryDate = new Date(
          Date.now() + 7 * 24 * 60 * 60 * 1000,
        ).toLocaleDateString("en-IN");

        const productRows = products.map((p) => ({
          description: `${p.productName} (${p.productCategory || ""})`,
          quantity: p.productQuantity,
          weight: p.productQuantity
            ? (
                parseFloat(form.shipmentWeight || 0) /
                parseInt(p.productQuantity)
              ).toFixed(2)
            : "0.00",
          pricePerUnit: parseFloat(p.productValue || 0).toFixed(2),
          total: (
            parseInt(p.productQuantity || 0) * parseFloat(p.productValue || 0)
          ).toFixed(2),
        }));

        // Use lmbpData from API response
        const companyAddress = lmbpData.address || "Address not available";
        const companyContact = lmbpData.phone
          ? `Phone: ${lmbpData.phone}${
              lmbpData.email ? ` / Email: ${lmbpData.email}` : ""
            }`
          : "Contact not available";
        const companyName = lmbpData.name || "Appan Courier Services";
        const lmbpBusinessType = lmbpData.lmbpBusinessType;

        const preparedReceiptData = {
          receiptNumber,
          receiptDate,
          customerName,
          consigneeName: form.consigneeName,
          consigneeContact: form.consigneeMobile,
          consignorAddress,
          customerAddress,
          customerContact,
          productRows,
          grandTotal,
          orderId,
          trackingNumber,
          pickupLocation,
          deliveryAddress,
          expectedDeliveryDate,
          paymentMode,
          expressType: form.expressType,
          amountPaid,
          balanceDue,
          courierCompany: "Appan Courier",
          companyAddress,
          companyContact,
          returnAddress,
          companyName,
          ourWaybillNumber: form.ourWaybillNumber,
          totalAmount:
            (parseFloat(chargesData?.totalCharges) || 0) +
            (parseFloat(codCharges) || 0),
          gstAmount: chargesData?.gstAmount,
          weight: chargesData?.weight,
          gstPercent: chargesData?.gstPercent,
          baseAmount: chargesData?.baseAmount,
          fuelCharges: chargesData?.fuelCharges,
          codAmount: chargesData?.codAmount,
          lmbpBusinessType: lmbpBusinessType,
        };

        setPincodeCheck(false);

        if (onSuccess) {
          onSuccess(preparedReceiptData);
        }

        // Reset form (same as before)
        setForm({
          consigneeName: "",
          consigneeMobile: "",
          consigneePhone: "",
          consigneeEmailId: "",
          consigneeAddress1: "",
          consigneePincode: "",
          consigneeCity: "",
          consigneeState: "",
          consigneeCountry: "",
          paymentMode: "",
          expressType: "",
          isNdd: "0",
          orderAmount: "",
          codAmount: "",
          invoiceNumber: "",
          shipmentWeight: "",
          shipmentLength: "",
          shipmentWidth: "",
          shipmentHeight: "",
          shipmentType: "",
          pickAddressId: "",
          returnAddressId: "",
          carrier_id: "",
          ourWaybillNumber: "",
          ewaybillNumber: "",
        });

        setProducts([
          {
            productName: "",
            productQuantity: "",
            productValue: "",
            productCategory: "",
            productDescription: "",
            productSku: "",
            productHsnsac: "",
            productTaxper: "",
          },
        ]);

        setErrors({});
        setProductErrors([{}]);

        if (typeof refreshTable === "function") {
          refreshTable(); // refresh OrderMaster table
        }

        // Close the CreateOrderModal and hide charges modal
        setShowChargesModal(false);
        setChargesData(null);
        handleClose();
      } else {
        CustomAlert({
          title: "Error",
          text:
            response?.data?.message ||
            "Failed to create order. Please try again.",
          icon: "error",
          confirmButtonText: "Okay",
          customClass: {
            container: "z-[99999]",
            popup: "z-[99999]",
          },
        });
        setShowChargesModal(false);
      }
    } catch (error) {
      console.error("Create Order API error:", error);
      CustomAlert({
        title: "Error",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "An error occurred while creating the order. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
        customClass: {
          container: "z-[99999]",
          popup: "z-[99999]",
        },
      });
    } finally {
      setLoading(false);
      setChargesLoading(false);
    }
  };

  const handlePincodeServiceability = async () => {
    if (!form?.consigneePincode || form.consigneePincode.length !== 6) {
      CustomAlert({
        title: "Warning",
        text: "Please enter a valid 6-digit consignee pincode first",
        icon: "warning",
        confirmButtonText: "Okay",
        customClass: {
          container: "z-[99999]",
          popup: "z-[99999]",
        },
      });
      return;
    }

    setLoading(true);
    try {
      const payload = {
        username: loggedInUserName,
        source_pincode: dashboardData?.wallet?.pincode,
        destination_pincode: form?.consigneePincode,
      };
      const response = await axiosPostApi(
        apiList.PINCODE_SERVICEABILITY,
        payload,
      );

      const shypmeData = response?.data?.data?.shypme;
      const delhiveryData = response?.data?.data?.delhivery;
      const delcaperData = response?.data?.data?.delcaper;

      // Check if at least one service is available
      const isServiceable =
        shypmeData?.serviceable === true || delhiveryData?.serviceable === true || delcaperData?.serviceable === true;

      if (
        form?.paymentMode === "COD" &&
        delhiveryData?.serviceable === true &&
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        // Nothing
      } else if (
        response?.data?.status === true &&
        response?.data?.respCode === "00" &&
        isServiceable
      ) {
        CustomAlert({
          title: "Success",
          text: "Pincode is serviceable",
          icon: "success",
          confirmButtonText: "OK",
          customClass: {
            container: "z-[99999]",
            popup: "z-[99999]",
          },
        });
        setPincodeCheck(true);
      } else {
        CustomAlert({
          title: "Failed",
          text: "Pincode is not serviceable",
          icon: "error",
          confirmButtonText: "Retry",
          customClass: {
            container: "z-[99999]",
            popup: "z-[99999]",
          },
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
        customClass: {
          container: "z-[99999]",
          popup: "z-[99999]",
        },
      });
      setPincodeCheck(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (form?.paymentMode === "COD" && form?.consigneePincode?.length === 6) {
      handlePincodeServiceability();
    }
  }, [form?.paymentMode, form?.consigneePincode]);

  // Removed handleCloseReceipt
  const fetchAddressDetails = async () => {
    setPreviousAddressLength(addressDetails.length);
    setLoadingAddresses(true);
    try {
      const response = await axiosGetApi(
        `${apiList.FETCH_ADDRESS_DETAILS}?username=${loggedInUserName}`,
      );
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        let data = response?.data?.data;
        // Generate unique optnAddressId if null or missing from backend
        const seenIds = new Set();
        data.forEach((addr) => {
          if (addr.optnAddressId) {
            seenIds.add(addr.optnAddressId.toString());
          }
        });
        let idCounter = 1;
        data = data.map((addr) => {
          let optnId = addr.optnAddressId;
          if (!optnId || !optnId.toString()) {
            while (seenIds.has(idCounter.toString())) {
              idCounter++;
            }
            optnId = idCounter.toString();
            idCounter++;
            seenIds.add(optnId);
          }
          return {
            ...addr,
            optnAddressId: optnId,
            fullAddress: addr.fullAddress
              ? addr.fullAddress.trim()
              : `${addr.address1 || ""} ${addr.address2 || ""}`.trim() ||
                "Address not specified",
            city: addr.city || "Not specified",
            state: addr.state || "Not specified",
            pinCode: addr.pinCode || "Not specified",
            phone: addr.phone || "Not specified",
          };
        });
        setAddressDetails(data);
        if (expectNewAddress && data.length > previousAddressLength) {
          const newAddress = data[data.length - 1];
          setForm((prev) => ({
            ...prev,
            pickAddressId: newAddress.optnAddressId,
            returnAddressId: newAddress.optnAddressId,
          }));
          setExpectNewAddress(false);
        }
      } else {
        setAddressDetails([]);
        CustomAlert({
          title: "Failed",
          text: response?.data?.message || "No addresses found.",
          icon: "error",
          customClass: {
            container: "z-[99999]",
            popup: "z-[99999]",
          },
        });
      }
    } catch (error) {
      setAddressDetails([]);
      CustomAlert({
        title: "Error",
        text: "Something went wrong while fetching addresses.",
        icon: "error",
        customClass: {
          container: "z-[99999]",
          popup: "z-[99999]",
        },
      });
    } finally {
      setLoadingAddresses(false);
    }
  };
  const displayReturnAddress = selectedReturnAddress || selectedPickupAddress;
  const isViewMode = action === "view";
  const isDeleteMode = action === "delete";
  const isEditMode = action === "modify";
  const isCancelMode = action === "cancelOrder";
  const isReadOnly = isViewMode || isDeleteMode || isCancelMode;
  const hasPickup = !!form.pickAddressId;
  // Function to toggle section visibility
  const toggleSection = (section) => {
    setSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };


  if (!show) return null;
  return createPortal(
    <>
      <div className={styles["overlay-style"]}>
        <div
          className={`${styles["modal-style"]} overflow-hidden`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="relative flex justify-between items-center p-4 !pl-0">
            <div className="flex items-center">
              <img
                src={AddVectorIcon}
                alt="Add Icon"
                className="w-[43px] h-[38px] mr-2"
              />
              <h5 className="modal-title main-title font-medium text-[18px]">
                {isViewMode || isCancelMode
                  ? "View Order"
                  : isDeleteMode
                  ? "Delete Order"
                  : isEditMode
                  ? "Modify Order"
                  : "Create New Order"}
              </h5>
            </div>
            <button
              onClick={handleClose}
              title="Close"
              className="absolute top-2 right-4 text-gray-500 hover:text-red-500 text-5xl leading-none focus:outline-none"
            >
              &times;
            </button>
          </div>
          <form className="h-[77vh] overflow-auto custom-scrollbar pb-5">
            {/* --------------------------------Consignee Details----------------------------------- */}
            <div
              className={styles["product-container-style"]}
              style={{ backgroundColor: "#f9fafb" }}
            >
              <div className="flex items-center mb-4 space-x-3">
                <button
                  type="button"
                  onClick={() => toggleSection("consigneeDetails")}
                  className="text-gray-600 hover:text-gray-800 focus:outline-none"
                >
                  {sections.consigneeDetails ? (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1="5" y1="12" x2="19" y2="12" />
                    </svg>
                  ) : (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1="12" y1="5" x2="12" y2="19" />
                      <line x1="5" y1="12" x2="19" y2="12" />
                    </svg>
                  )}
                </button>
                <h2 className="modal-title main-title">
                  Consignee Details (Receiver)
                </h2>
              </div>
              {sections.consigneeDetails && (
                <>
                  {/* Row 1 */}
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                    {/* Consignee Name */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Consignee Name <span className="text-red-500">*</span>
                      </label>
                      <div className="relative w-full">
                        {/* Icon */}
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <PersonOutlinedIcon
                            className="text-gray"
                            sx={{ width: 20, height: 20 }}
                          />
                        </span>
                        <input
                          className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                          name="consigneeName"
                          value={form.consigneeName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Enter consignee name"
                          disabled={isReadOnly}
                        />
                      </div>
                      {errors.consigneeName && (
                        <p className="text-sm text-red-500 mt-1">
                          {errors.consigneeName}
                        </p>
                      )}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Consignee Mobile <span className="text-red-500">*</span>
                      </label>
                      {/* Consignee Mobile */}
                      <div className="relative w-full">
                        {/* Icon */}
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <PhoneIcon
                            className="text-gray"
                            sx={{ width: 20, height: 20 }}
                          />
                        </span>
                        <input
                          className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                          name="consigneeMobile"
                          value={form.consigneeMobile}
                          onChange={(e) => {
                            const onlyDigits = e.target.value
                              .replace(/\D/g, "")
                              .slice(0, 10); // Only digits, max 10
                            setForm((prev) => ({
                              ...prev,
                              consigneeMobile: onlyDigits,
                            }));
                            setErrors((prev) => ({
                              ...prev,
                              consigneeMobile: validateField(
                                "consigneeMobile",
                                onlyDigits,
                              ),
                            }));
                          }}
                          onBlur={handleBlur}
                          placeholder="Enter consignee mobile"
                          disabled={isReadOnly}
                        />
                      </div>
                      {errors.consigneeMobile && (
                        <p className="text-sm text-red-500 mt-1">
                          {errors.consigneeMobile}
                        </p>
                      )}
                    </div>
                    {/* Consignee Phone */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Consignee Phone
                      </label>
                      <div className="relative w-full">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <PhoneIcon
                            className="text-gray"
                            sx={{ width: 20, height: 20 }}
                          />
                        </span>
                        <input
                          className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                          name="consigneePhone"
                          value={form.consigneePhone}
                          onChange={(e) => {
                            const onlyDigits = e.target.value
                              .replace(/\D/g, "")
                              .slice(0, 10); // only 10 digits
                            setForm((prev) => ({
                              ...prev,
                              consigneePhone: onlyDigits,
                            }));
                            setErrors((prev) => ({
                              ...prev,
                              consigneePhone: validateField(
                                "consigneePhone",
                                onlyDigits,
                              ),
                            }));
                          }}
                          onBlur={handleBlur}
                          placeholder="Enter consignee phone"
                          disabled={isReadOnly}
                        />
                      </div>
                      {errors.consigneePhone && (
                        <p className="text-sm text-red-500 mt-1">
                          {errors.consigneePhone}
                        </p>
                      )}
                    </div>
                    {/* Consignee Email */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Consignee Email Id{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <div className="relative w-full">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <EmailIcon
                            className="text-gray"
                            sx={{ width: 20, height: 20 }}
                          />
                        </span>
                        <input
                          className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                          name="consigneeEmailId"
                          value={form.consigneeEmailId}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Enter consignee email id"
                          disabled={isReadOnly}
                        />
                      </div>
                      {errors.consigneeEmailId && (
                        <p className="text-sm text-red-500 mt-1">
                          {errors.consigneeEmailId}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Consignee Address 1{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <div className="relative w-full">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <LocationOnIcon
                            className="text-gray"
                            sx={{ width: 20, height: 20 }}
                          />
                        </span>
                        <input
                          className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                          name="consigneeAddress1"
                          value={form.consigneeAddress1}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Enter consignee address 1"
                          disabled={isReadOnly}
                          minLength={20}
                        />
                      </div>
                      {errors.consigneeAddress1 && (
                        <div className="text-sm text-red-600 mt-1">
                          {errors.consigneeAddress1}
                        </div>
                      )}
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Consignee Pincode{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <div className="flex items-center space-x-2">
                          <div className="relative w-full">
                            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                              <PinCodeIcon
                                className="text-gray"
                                sx={{ width: 20, height: 20 }}
                              />
                            </span>
                            <input
                              className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                              name="consigneePincode"
                              value={form.consigneePincode}
                              maxLength={6}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              onBlur={handleBlur}
                              placeholder="Enter consignee pincode"
                              disabled={pincodeLoading || isReadOnly}
                            />
                          </div>
                          <button
                            type="button"
                            className="btn btn-submit !rounded-[8px]"
                            onClick={() => handlePincodeServiceability()}
                            disabled={
                              isReadOnly ||
                              pincodeLoading ||
                              !form.consigneePincode
                            }
                          >
                            Check
                          </button>
                        </div>
                        {pincodeLoading && (
                          <div className="text-sm text-gray-500 mt-1">
                            Fetching details...
                          </div>
                        )}
                        {errors.consigneePincode && (
                          <div className="text-sm text-red-600 mt-1">
                            {errors.consigneePincode}
                          </div>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Consignee City <span className="text-red-500">*</span>
                        </label>
                        <div className="relative w-full">
                          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                            <BusinessIcon
                              className="text-gray"
                              sx={{ width: 20, height: 20 }}
                            />
                          </span>
                          <input
                            className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            name="consigneeCity"
                            value={form.consigneeCity}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Enter consignee city"
                            disabled
                          />
                        </div>
                        {errors.consigneeCity && (
                          <div className="text-sm text-red-600 mt-1">
                            {errors.consigneeCity}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6 mt-6">
                    {/* State - Wider Now */}
                    <div className="flex flex-col w-[255px]">
                      <label className="text-sm font-medium text-gray-700 mb-1">
                        Consignee State <span className="text-red-500">*</span>
                      </label>
                      <div className="relative w-full">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <StateIcon
                            className="text-gray"
                            sx={{ width: 20, height: 20 }}
                          />
                        </span>
                        <input
                          className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                          name="consigneeState"
                          value={form.consigneeState}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Enter consignee state"
                          disabled
                        />
                      </div>
                      {errors.consigneeState && (
                        <span className="text-sm text-red-500 mt-1">
                          {errors.consigneeState}
                        </span>
                      )}
                    </div>
                    {/* Country - Wider Now */}
                    <div className="flex flex-col w-[255px] ml-9">
                      <label className="text-sm font-medium text-gray-700 mb-1">
                        Consignee Country{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <div className="relative w-full">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <PublicIcon
                            className="text-gray"
                            sx={{ width: 20, height: 20 }}
                          />
                        </span>
                        <input
                          className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                          name="consigneeCountry"
                          value={form.consigneeCountry}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Enter consignee country"
                          disabled
                        />
                      </div>
                      {errors.consigneeCountry && (
                        <span className="text-sm text-red-500 mt-1">
                          {errors.consigneeCountry}
                        </span>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
            {/* --------------------------------Consignor Details----------------------------------- */}
            <div
              className={styles["product-container-style"]}
              style={{ backgroundColor: "#f9fafb" }}
            >
              <div className="flex items-center mb-4 space-x-3">
                <button
                  type="button"
                  onClick={() => toggleSection("consignorDetails")}
                  className="text-gray-600 hover:text-gray-800 focus:outline-none"
                >
                  {sections.consignorDetails ? (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1="5" y1="12" x2="19" y2="12" />
                    </svg>
                  ) : (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1="12" y1="5" x2="12" y2="19" />
                      <line x1="5" y1="12" x2="19" y2="12" />
                    </svg>
                  )}
                </button>
                <h2 className="modal-title main-title">
                  Consignor Details (Sender)
                </h2>
              </div>
              {sections.consignorDetails && (
                <>
                  {/* Row 1 */}
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                    {/* Consignor Name */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Consignor Name <span className="text-red-500">*</span>
                      </label>
                      <div className="relative w-full">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <PersonOutlinedIcon
                            className="text-gray"
                            sx={{ width: 20, height: 20 }}
                          />
                        </span>
                        <input
                          className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                          name="consignorName"
                          value={form.consignorName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Enter consignor name"
                          disabled={isReadOnly}
                        />
                      </div>
                      {errors.consignorName && (
                        <p className="text-sm text-red-500 mt-1">
                          {errors.consignorName}
                        </p>
                      )}
                    </div>
                    {/* Consignor Mobile */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Consignor Mobile <span className="text-red-500">*</span>
                      </label>
                      <div className="relative w-full">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <PhoneIcon
                            className="text-gray"
                            sx={{ width: 20, height: 20 }}
                          />
                        </span>
                        <input
                          className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                          name="consignorMobile"
                          value={form.consignorMobile}
                          onChange={(e) => {
                            const onlyDigits = e.target.value
                              .replace(/\D/g, "")
                              .slice(0, 10);
                            setForm((prev) => ({
                              ...prev,
                              consignorMobile: onlyDigits,
                            }));
                            setErrors((prev) => ({
                              ...prev,
                              consignorMobile: validateField(
                                "consignorMobile",
                                onlyDigits,
                              ),
                            }));
                          }}
                          onBlur={handleBlur}
                          placeholder="Enter consignor mobile"
                          disabled={isReadOnly}
                        />
                      </div>
                      {errors.consignorMobile && (
                        <p className="text-sm text-red-500 mt-1">
                          {errors.consignorMobile}
                        </p>
                      )}
                    </div>
                    {/* Consignor Phone */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Consignor Phone
                      </label>
                      <div className="relative w-full">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <PhoneIcon
                            className="text-gray"
                            sx={{ width: 20, height: 20 }}
                          />
                        </span>
                        <input
                          className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                          name="consignorPhone"
                          value={form.consignorPhone}
                          onChange={(e) => {
                            const onlyDigits = e.target.value
                              .replace(/\D/g, "")
                              .slice(0, 10);
                            setForm((prev) => ({
                              ...prev,
                              consignorPhone: onlyDigits,
                            }));
                            setErrors((prev) => ({
                              ...prev,
                              consignorPhone: validateField(
                                "consignorPhone",
                                onlyDigits,
                              ),
                            }));
                          }}
                          onBlur={handleBlur}
                          placeholder="Enter consignor phone"
                          disabled={isReadOnly}
                        />
                      </div>
                      {errors.consignorPhone && (
                        <p className="text-sm text-red-500 mt-1">
                          {errors.consignorPhone}
                        </p>
                      )}
                    </div>
                    {/* Consignor Email */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Consignor Email Id{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <div className="relative w-full">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <EmailIcon
                            className="text-gray"
                            sx={{ width: 20, height: 20 }}
                          />
                        </span>
                        <input
                          className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                          name="consignorEmailId"
                          value={form.consignorEmailId}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Enter consignor email id"
                          disabled={isReadOnly}
                        />
                      </div>
                      {errors.consignorEmailId && (
                        <p className="text-sm text-red-500 mt-1">
                          {errors.consignorEmailId}
                        </p>
                      )}
                    </div>
                  </div>
                  {/* Address */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Consignor Address 1{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <div className="relative w-full">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <LocationOnIcon
                            className="text-gray"
                            sx={{ width: 20, height: 20 }}
                          />
                        </span>
                        <input
                          className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                          name="consignorAddress1"
                          value={form.consignorAddress1}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Enter consignor address 1"
                          disabled={isReadOnly}
                          minLength={20}
                        />
                      </div>
                      {errors.consignorAddress1 && (
                        <div className="text-sm text-red-600 mt-1">
                          {errors.consignorAddress1}
                        </div>
                      )}
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Consignor Pincode{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <div className="relative w-full">
                          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                            <PinCodeIcon
                              className="text-gray"
                              sx={{ width: 20, height: 20 }}
                            />
                          </span>
                          <input
                            className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            name="consignorPincode"
                            value={form.consignorPincode}
                            maxLength={6}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Enter consignor pincode"
                            disabled={pincodeLoading || isReadOnly}
                          />
                        </div>
                        {errors.consignorPincode && (
                          <div className="text-sm text-red-600 mt-1">
                            {errors.consignorPincode}
                          </div>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Consignor City <span className="text-red-500">*</span>
                        </label>
                        <div className="relative w-full">
                          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                            <BusinessIcon
                              className="text-gray"
                              sx={{ width: 20, height: 20 }}
                            />
                          </span>
                          <input
                            className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            name="consignorCity"
                            value={form.consignorCity}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Enter consignor city"
                            disabled
                          />
                        </div>
                        {errors.consignorCity && (
                          <div className="text-sm text-red-600 mt-1">
                            {errors.consignorCity}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* State & Country */}
                  <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6 mt-6">
                    <div className="flex flex-col w-[255px]">
                      <label className="text-sm font-medium text-gray-700 mb-1">
                        Consignor State <span className="text-red-500">*</span>
                      </label>
                      <div className="relative w-full">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <StateIcon
                            className="text-gray"
                            sx={{ width: 20, height: 20 }}
                          />
                        </span>
                        <input
                          className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                          name="consignorState"
                          value={form.consignorState}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Enter consignor state"
                          disabled
                        />
                      </div>
                      {errors.consignorState && (
                        <span className="text-sm text-red-500 mt-1">
                          {errors.consignorState}
                        </span>
                      )}
                    </div>
                    <div className="flex flex-col w-[255px] ml-9">
                      <label className="text-sm font-medium text-gray-700 mb-1">
                        Consignor Country{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <div className="relative w-full">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <PublicIcon
                            className="text-gray"
                            sx={{ width: 20, height: 20 }}
                          />
                        </span>
                        <input
                          className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                          name="consignorCountry"
                          value={form.consignorCountry}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Enter consignor country"
                          disabled
                        />
                      </div>
                      {errors.consignorCountry && (
                        <span className="text-sm text-red-500 mt-1">
                          {errors.consignorCountry}
                        </span>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
            {/* --------------------------------Order Details----------------------------------- */}
            {/* 2 Section */}
            <div
              className={`${styles["product-container-style"]} pt-6`}
              style={{ backgroundColor: "#f9fafb" }}
            >
              <div className="flex items-center mb-4 space-x-3">
                <button
                  type="button"
                  onClick={() => toggleSection("orderDetails")}
                  className="text-gray-600 hover:text-gray-800 focus:outline-none"
                >
                  {sections.orderDetails ? (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <line x1="5" y1="12" x2="19" y2="12" />
                    </svg>
                  ) : (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <line x1="12" y1="5" x2="12" y2="19" />
                      <line x1="5" y1="12" x2="19" y2="12" />
                    </svg>
                  )}
                </button>
                <h2 className="modal-title main-title">Order Details</h2>
              </div>

              {sections.orderDetails && (
                <div className="grid grid-cols-1 md:grid-cols-5 gap-6 mb-6">
                  {/* Payment Mode */}
                  <div className="flex flex-col w-full">
                    <label className="text-sm font-medium text-gray-700 mb-1">
                      Payment Mode <span className="text-red-500">*</span>
                    </label>
                    <div className="relative w-full">
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                        <CreditCardIcon
                          className="text-gray"
                          sx={{ width: 20, height: 20 }}
                        />
                      </span>
                      <select
                        className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        name="paymentMode"
                        value={form.paymentMode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={isReadOnly}
                      >
                        <option value="" className="text-gray">
                          -Select Mode-
                        </option>
                        <option value="COD">Cash On Delivery</option>
                        <option value="PPD">PPD</option>
                      </select>
                    </div>
                    {errors.paymentMode && (
                      <span className="text-sm text-red-500 mt-1">
                        {errors.paymentMode}
                      </span>
                    )}
                  </div>

                  {/* Order Amount */}
                  <div className="flex flex-col w-full">
                    <label className="text-sm font-medium text-gray-700 mb-1">
                      Order Amount <span className="text-red-500">*</span>
                    </label>
                    <div className="relative w-full">
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                        <RupeeIcon
                          className="text-gray"
                          sx={{ width: 20, height: 20 }}
                        />
                      </span>
                      <input
                        className="w-full text-right pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        name="orderAmount"
                        value={form.orderAmount}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="0.00"
                        disabled={!form.paymentMode || isReadOnly}
                      />
                    </div>
                    {errors.orderAmount && (
                      <span className="text-sm text-red-500 mt-1">
                        {errors.orderAmount}
                      </span>
                    )}
                  </div>

                  {/* COD Amount */}
                  {form?.paymentMode === "COD" && (
                    <div className="flex flex-col w-full">
                      <label className="text-sm font-medium text-gray-700 mb-1">
                        COD Amount
                      </label>
                      <div className="relative w-full">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <RupeeIcon
                            className="text-gray"
                            sx={{ width: 20, height: 20 }}
                          />
                        </span>
                        <input
                          className="w-full text-right pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                          name="codAmount"
                          value={form.codAmount}
                          onChange={(e) => {
                            const input = e.target.value;
                            if (/^\d*\.?\d{0,2}$/.test(input)) {
                              setForm((prev) => ({
                                ...prev,
                                codAmount: input,
                              }));
                              setErrors((prev) => ({
                                ...prev,
                                codAmount: validateField("codAmount", input, {
                                  ...form,
                                  codAmount: input,
                                }),
                              }));
                            }
                          }}
                          onBlur={handleBlur}
                          placeholder="0.00"
                          disabled={
                            !form.paymentMode ||
                            form.paymentMode === "PPD" ||
                            isReadOnly
                          }
                        />
                      </div>
                      {errors.codAmount && (
                        <span className="text-sm text-red-500 mt-1">
                          {errors.codAmount}
                        </span>
                      )}
                    </div>
                  )}

                  {/* Our WaybillNumber Field */}
                  <div className="flex flex-col w-full">
                    <label className="text-sm font-medium text-gray-700 mb-1">
                      Our Waybill Number <span className="text-red-500">*</span>
                    </label>
                    <div className="relative w-full">
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                        <TagIcon
                          className="text-gray"
                          sx={{ width: 20, height: 20 }}
                        />
                      </span>
                      <input
                        className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        name="ourWaybillNumber"
                        value={form.ourWaybillNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Enter Our Waybill Number"
                        maxLength={25}
                        disabled={isReadOnly || action === "view"}
                      />
                    </div>
                    {errors.ourWaybillNumber && (
                      <span className="text-sm text-red-500 mt-1">
                        {errors.ourWaybillNumber}
                      </span>
                    )}
                  </div>

                  {/* Conditional EwayBill Number Field - Only shown when Order Amount >= 50000 */}
                  {parseFloat(form.orderAmount || 0) >= 50000 && (
                    <div className="flex flex-col w-full">
                      <label className="text-sm font-medium text-gray-700 mb-1">
                        EwayBill Number
                      </label>
                      <div className="relative w-full">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <TagIcon
                            className="text-gray"
                            sx={{ width: 20, height: 20 }}
                          />
                        </span>
                        <input
                          className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-100"
                          name="ewaybillNumber"
                          value={form.ourWaybillNumber}
                          readOnly
                          placeholder="Auto-filled from Our Waybill Number"
                        />
                      </div>
                    </div>
                  )}

                  {/* Invoice Number */}
                  <div className="flex flex-col w-full">
                    <label className="text-sm font-medium text-gray-700 mb-1">
                      Invoice Number
                    </label>
                    <div className="relative w-full">
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                        <TagIcon
                          className="text-gray"
                          sx={{ width: 20, height: 20 }}
                        />
                      </span>
                      <input
                        className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        name="invoiceNumber"
                        value={form.invoiceNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Enter invoice number"
                        disabled={isReadOnly}
                      />
                    </div>
                    {errors.invoiceNumber && (
                      <span className="text-sm text-red-500 mt-1">
                        {errors.invoiceNumber}
                      </span>
                    )}
                  </div>

                  {/* Express Type */}
                  <div className="flex flex-col w-full">
                    <label className="text-sm font-medium text-gray-700 mb-1">
                      Express Type <span className="text-red-500">*</span>
                    </label>
                    <div className="relative w-full">
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                        <ShippingIcon
                          className="text-gray"
                          sx={{ width: 20, height: 20 }}
                        />
                      </span>
                      <select
                        className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        name="expressType"
                        value={form.expressType}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={isReadOnly}
                      >
                        <option value="">Select Express Type</option>
                        <option value="air">Air</option>
                        <option value="surface">Surface</option>
                      </select>
                    </div>
                    {errors.expressType && (
                      <span className="text-sm text-red-500 mt-1">
                        {errors.expressType}
                      </span>
                    )}
                  </div>

                  {/* Is NDD */}
                  <div className="flex flex-col w-full">
                    <label className="text-sm font-medium text-gray-700 mb-1">
                      Is NDD
                    </label>
                    <div className="relative w-full">
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                        <TagIcon
                          className="text-gray"
                          sx={{ width: 20, height: 20 }}
                        />
                      </span>
                      <select
                        className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        name="isNdd"
                        value={form.isNdd}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={isReadOnly}
                      >
                        <option value="0">0</option>
                        <option value="1">1</option>
                      </select>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* -----------------------------Shipment Details-------------------------------------- */}
            <div
              className={styles["product-container-style"]}
              style={{ backgroundColor: "#f9fafb" }}
            >
              <div className="flex items-center mb-4 space-x-3">
                <button
                  type="button"
                  onClick={() => toggleSection("shipmentDetails")}
                  className="text-gray-600 hover:text-gray-800 focus:outline-none"
                >
                  {sections.shipmentDetails ? (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1="5" y1="12" x2="19" y2="12" />
                    </svg>
                  ) : (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1="12" y1="5" x2="12" y2="19" />
                      <line x1="5" y1="12" x2="19" y2="12" />
                    </svg>
                  )}
                </button>
                <h2 className="modal-title main-title">Shipment Details</h2>
              </div>
              {sections?.shipmentDetails && (
                <>
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                    {/* Shipment Weight */}
                    <div className="flex flex-col w-[290px]">
                      <label className="text-sm font-medium text-gray-700 mb-1">
                        shipment Weight <span className="text-red-500">*</span>
                      </label>
                      <div className="flex gap-[2px]">
                        <div className="relative">
                          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                            <FaBalanceScale className="text-gray" />
                          </span>
                          <input
                            name="shipmentWeight"
                            value={form.shipmentWeight}
                            onChange={(e) => {
                              const input = e.target.value;
                              if (/^\d*\.?\d{0,2}$/.test(input)) {
                                setForm((prev) => ({
                                  ...prev,
                                  shipmentWeight: input,
                                }));
                                setErrors((prev) => ({
                                  ...prev,
                                  shipmentWeight: validateField(
                                    "shipmentWeight",
                                    input,
                                    {
                                      ...form,
                                      shipmentWeight: input,
                                    },
                                  ),
                                }));
                              }
                            }}
                            // onBlur={handleBlur}
                            onBlur={(e) => {
                              const value = e.target.value;
                              // Format value to .00 on blur
                              const formatted =
                                value && !isNaN(value)
                                  ? parseFloat(value).toFixed(2)
                                  : "";
                              setForm((prev) => ({
                                ...prev,
                                shipmentWeight: formatted,
                              }));
                            }}
                            className="text-right placeholder:text-left pl-10 pr-4 py-2 h-[38px] w-[230px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Enter shipment weight"
                            disabled={isReadOnly}
                          />
                        </div>
                        <div className="bg-[#2e237f] text-[#FFFFFF] h-[38px] w-[40px] rounded-r-lg flex items-center justify-center font-medium">
                          kg
                        </div>
                      </div>
                      {errors.shipmentWeight && (
                        <span className="text-sm text-red-500 mt-1">
                          {errors.shipmentWeight}
                        </span>
                      )}
                    </div>
                    {/* Shipment Length */}
                    <div className="flex flex-col w-[290px] ">
                      <label className="text-sm font-medium text-gray-700 mb-1">
                        Shipment Length <span className="text-red-500">*</span>
                      </label>
                      <div className="flex gap-[2px]">
                        <div className="relative">
                          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                            <StraightenIcon
                              className="text-gray"
                              sx={{ width: 20, height: 20 }}
                            />
                          </span>
                          <input
                            name="shipmentLength"
                            value={form.shipmentLength}
                            onChange={(e) => {
                              const input = e.target.value;
                              if (/^\d*\.?\d{0,2}$/.test(input)) {
                                setForm((prev) => ({
                                  ...prev,
                                  shipmentLength: input,
                                }));
                                setErrors((prev) => ({
                                  ...prev,
                                  shipmentLength: validateField(
                                    "shipmentLength",
                                    input,
                                    {
                                      ...form,
                                      shipmentLength: input,
                                    },
                                  ),
                                }));
                              }
                            }}
                            onBlur={(e) => {
                              const input = e?.target?.value?.trim();
                              // Protect against long or repeated digits
                              const isRepeated =
                                /^(\d)\1{4,}(\.\d{1,2})?$/.test(input); // e.g. 11111.00
                              const isTooLong = input.length > 10; // Avoid formatting huge input
                              if (isRepeated || isTooLong) {
                                setErrors((prev) => ({
                                  ...prev,
                                  shipmentLength:
                                    "Invalid or repeated digits not allowed",
                                }));
                                return;
                              }
                              const formatted =
                                input && !isNaN(input)
                                  ? parseFloat(input).toFixed(2)
                                  : "";
                              setForm((prev) => ({
                                ...prev,
                                shipmentLength: formatted,
                              }));
                              setErrors((prev) => ({
                                ...prev,
                                shipmentLength: validateField(
                                  "shipmentLength",
                                  formatted,
                                  {
                                    ...form,
                                    shipmentLength: formatted,
                                  },
                                ),
                              }));
                            }}
                            placeholder="Enter shipment length"
                            className="text-right placeholder:text-left pl-10 pr-4 py-2 h-[38px] w-[230px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            disabled={isReadOnly}
                          />
                        </div>
                        <div className="bg-[#2e237f] text-[#FFFFFF] h-[38px] w-[40px] rounded-r-lg flex items-center justify-center font-medium">
                          cm
                        </div>
                      </div>
                      {errors.shipmentLength && (
                        <span className="text-sm text-red-500 mt-1">
                          {errors.shipmentLength}
                        </span>
                      )}
                    </div>
                    {/* Shipment Width */}
                    <div className="flex flex-col w-[290px]">
                      <label className="text-sm font-medium text-gray-700 mb-1">
                        Shipment Width <span className="text-red-500">*</span>
                      </label>
                      <div className="flex gap-[2px]">
                        <div className="relative">
                          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                            <RxDimensions
                              className="text-gray"
                              sx={{ width: 20, height: 20 }}
                            />
                          </span>
                          <input
                            name="shipmentWidth"
                            value={form.shipmentWidth}
                            onChange={(e) => {
                              const input = e.target.value;
                              if (/^\d*\.?\d{0,2}$/.test(input)) {
                                setForm((prev) => ({
                                  ...prev,
                                  shipmentWidth: input,
                                }));
                                setErrors((prev) => ({
                                  ...prev,
                                  shipmentWidth: validateField(
                                    "shipmentWidth",
                                    input,
                                    {
                                      ...form,
                                      shipmentWidth: input,
                                    },
                                  ),
                                }));
                              }
                            }}
                            onBlur={(e) => {
                              const input = e?.target?.value?.trim();
                              const isRepeated =
                                /^(\d)\1{4,}(\.\d{1,2})?$/.test(input);
                              const isTooLong = input.length > 10;
                              if (isRepeated || isTooLong) {
                                setErrors((prev) => ({
                                  ...prev,
                                  shipmentWidth:
                                    "Invalid or repeated digits not allowed",
                                }));
                                return;
                              }
                              const formatted =
                                input && !isNaN(input)
                                  ? parseFloat(input).toFixed(2)
                                  : "";
                              setForm((prev) => ({
                                ...prev,
                                shipmentWidth: formatted,
                              }));
                              setErrors((prev) => ({
                                ...prev,
                                shipmentWidth: validateField(
                                  "shipmentWidth",
                                  formatted,
                                  {
                                    ...form,
                                    shipmentWidth: formatted,
                                  },
                                ),
                              }));
                            }}
                            className="text-right placeholder:text-left pl-10 pr-4 py-2 h-[38px] w-[230px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Enter shipment width"
                            disabled={isReadOnly}
                          />
                        </div>
                        <div className="bg-[#2e237f] text-[#FFFFFF] h-[38px] w-[40px] rounded-r-lg flex items-center justify-center font-medium">
                          cm
                        </div>
                      </div>
                      {errors.shipmentWidth && (
                        <span className="text-sm text-red-500 mt-1">
                          {errors.shipmentWidth}
                        </span>
                      )}
                    </div>
                    {/* Shipment Height */}
                    <div className="flex flex-col w-[290px]">
                      <label className="text-sm font-medium text-gray-700 mb-1">
                        Shipment Height <span className="text-red-500">*</span>
                      </label>
                      <div className="flex gap-[2px]">
                        <div className="relative">
                          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                            <RxDimensions
                              className="text-gray"
                              sx={{ width: 20, height: 20 }}
                            />
                          </span>
                          <input
                            className="text-right placeholder:text-left pl-10 pr-4 py-2 h-[38px] w-[230px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            name="shipmentHeight"
                            value={form.shipmentHeight}
                            onChange={(e) => {
                              const input = e.target.value;
                              if (/^\d*\.?\d{0,2}$/.test(input)) {
                                setForm((prev) => ({
                                  ...prev,
                                  shipmentHeight: input,
                                }));
                                setErrors((prev) => ({
                                  ...prev,
                                  shipmentHeight: validateField(
                                    "shipmentHeight",
                                    input,
                                    {
                                      ...form,
                                      shipmentHeight: input,
                                    },
                                  ),
                                }));
                              }
                            }}
                            onBlur={(e) => {
                              const input = e?.target?.value?.trim();
                              const isRepeated =
                                /^(\d)\1{4,}(\.\d{1,2})?$/.test(input);
                              const isTooLong = input.length > 10;
                              if (isRepeated || isTooLong) {
                                setErrors((prev) => ({
                                  ...prev,
                                  shipmentHeight:
                                    "Invalid or repeated digits not allowed",
                                }));
                                return;
                              }
                              const formatted =
                                input && !isNaN(input)
                                  ? parseFloat(input).toFixed(2)
                                  : "";
                              setForm((prev) => ({
                                ...prev,
                                shipmentHeight: formatted,
                              }));
                              setErrors((prev) => ({
                                ...prev,
                                shipmentHeight: validateField(
                                  "shipmentHeight",
                                  formatted,
                                  {
                                    ...form,
                                    shipmentHeight: formatted,
                                  },
                                ),
                              }));
                            }}
                            placeholder="Enter shipment height"
                            disabled={isReadOnly}
                          />
                        </div>
                        <div className="bg-[#2e237f] text-[#FFFFFF] h-[38px] w-[40px] rounded-r-lg flex items-center justify-center font-medium">
                          cm
                        </div>
                      </div>
                      {errors.shipmentHeight && (
                        <span className="text-sm text-red-500 mt-1">
                          {errors.shipmentHeight}
                        </span>
                      )}
                    </div>
                    {/* Shipment Type */}
                    <div className="flex flex-col w-full">
                      <label className="text-sm font-medium text-gray-700 mb-1">
                        Shipment Type <span className="text-red-500">*</span>
                      </label>
                      <div className="relative w-full">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <CreditCardIcon
                            className="text-gray"
                            sx={{ width: 20, height: 20 }}
                          />
                        </span>
                        <select
                          className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                          name="shipmentType"
                          value={form.shipmentType}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isReadOnly}
                        >
                          <option value="" className="text-gray">
                            -Select Type-
                          </option>
                          <option value="NON_DOX">Non Doc</option>
                          <option value="DOX">Doc</option>
                        </select>
                      </div>
                      {errors.shipmentType && (
                        <span className="text-sm text-red-500 mt-1">
                          {errors.shipmentType}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="flex items-center gap-2 mb-2">
                    <input
                      type="checkbox"
                      id="useConsignorForPickup"
                      checked={form.useConsignorForPickup}
                      disabled={isReadOnly}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setForm((prev) => ({
                          ...prev,
                          useConsignorForPickup: checked,
                          pickAddressId: checked ? "consignor" : "",
                          pickupAddressDetails: checked
                            ? {
                                addressTitle:
                                  prev?.consignorName || "Consignor",
                                fullAddress: prev?.consignorAddress1 || "",
                                city: prev?.consignorCity || "",
                                state: prev?.consignorState || "",
                                pinCode: prev?.consignorPincode || "",
                                phone:
                                  prev?.consignorMobile ||
                                  prev?.consignorPhone ||
                                  "",
                              }
                            : null,
                        }));
                      }}
                    />
                    <label
                      htmlFor="useConsignorForPickup"
                      className="text-sm font-medium text-gray-700"
                    >
                      Use consignor address as <br />
                      pickup address
                    </label>
                  </div>
                  <div
                    className={`mb-6 ${
                      hasPickup
                        ? "grid grid-cols-[22%_38%_38%] gap-3"
                        : "grid grid-cols-1 gap-4"
                    }`}
                  >
                    <div className="flex flex-col col-span-1">
                      <div className="flex flex-col w-[250px] mb-3 border-b-[3px] border-gray-900 border-dashed pb-3">
                        <label className="text-sm font-medium text-gray-700 mb-1">
                          Select Pickup Address{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <div className="relative w-full">
                          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                            <LocationOnIcon
                              className="text-gray"
                              sx={{ width: 20, height: 20 }}
                            />
                          </span>
                          <select
                            className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            name="pickAddressId"
                            value={form.pickAddressId}
                            // onChange={handleChange}
                            disabled={
                              isReadOnly ||
                              !form.expressType ||
                              loadingAddresses ||
                              form?.useConsignorForPickup
                            }
                            onChange={(e) => {
                              const selectedValue = e.target.value;
                              setForm((prev) => ({
                                ...prev,
                                pickAddressId: selectedValue,
                                returnAddressId: selectedValue,
                              }));
                              setErrors((prev) => ({
                                ...prev,
                                pickAddressId: validateField(
                                  "pickAddressId",
                                  selectedValue,
                                ),
                              }));
                            }}
                            onBlur={handleBlur}
                          >
                            {/* Show loading state */}
                            {loadingAddresses ? (
                              <option value="">Loading addresses...</option>
                            ) : (
                              <option value="">Select Address</option>
                            )}
                            {addressDetails?.map((address) => (
                              <option
                                key={address.addressTitle}
                                value={address.optnAddressId}
                              >
                                {address?.addressTitle}
                              </option>
                            ))}
                          </select>
                        </div>
                        {errors.pickAddressId && (
                          <span className="text-sm text-red-500 mt-1">
                            {errors.pickAddressId}
                          </span>
                        )}
                      </div>
                      <div className="flex items-center gap-2 mb-2 mt-2">
                        <input
                          type="checkbox"
                          id="useConsignorForReturn"
                          checked={form.useConsignorForReturn}
                          disabled={isReadOnly}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setForm((prev) => ({
                              ...prev,
                              useConsignorForReturn: checked, // ✅ Keep inside form for validation
                              returnAddressId: checked ? "consignor" : "",
                              returnAddressDetails: checked
                                ? {
                                    addressTitle:
                                      prev?.consignorName || "Consignor",
                                    fullAddress: prev?.consignorAddress1 || "",
                                    city: prev?.consignorCity || "",
                                    state: prev?.consignorState || "",
                                    pinCode: prev?.consignorPincode || "",
                                    phone:
                                      prev?.consignorMobile ||
                                      prev?.consignorPhone ||
                                      "",
                                  }
                                : null,
                            }));
                          }}
                        />
                        <label
                          htmlFor="useConsignorForReturn"
                          className="text-sm font-medium text-gray-700"
                        >
                          Use consignor address as <br />
                          return address
                        </label>
                      </div>
                      <div className="flex flex-col w-[250px]">
                        <label className="text-sm font-medium text-gray-700 mb-1">
                          Select Return Address{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <div className="relative w-full">
                          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                            <LocationOnIcon
                              className="text-gray"
                              sx={{ width: 20, height: 20 }}
                            />
                          </span>
                          <select
                            className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            name="returnAddressId"
                            value={form.returnAddressId}
                            disabled={
                              isReadOnly ||
                              !form.expressType ||
                              loadingAddresses ||
                              form?.useConsignorForReturn
                            }
                            onChange={(e) => {
                              const selectedValue = e.target.value;
                              setForm((prev) => ({
                                ...prev,
                                returnAddressId: selectedValue,
                              }));
                              setErrors((prev) => ({
                                ...prev,
                                returnAddressId: validateField(
                                  "returnAddressId",
                                  selectedValue,
                                ),
                              }));
                            }}
                            onBlur={handleBlur}
                          >
                            {/* Show loading state */}
                            {loadingAddresses ? (
                              <option value="">Loading addresses...</option>
                            ) : (
                              <option value="">Select Address</option>
                            )}
                            {addressDetails?.map((address) => (
                              <option
                                key={address.addressTitle}
                                value={address.optnAddressId}
                              >
                                {address?.addressTitle}
                              </option>
                            ))}
                          </select>
                        </div>
                        {errors.returnAddressId && (
                          <span className="text-sm text-red-500 mt-1">
                            {errors.returnAddressId}
                          </span>
                        )}
                      </div>
                      {!isReadOnly && (
                        <button
                          type="button"
                          className="mt-2 self-start px-4 py-2 bg-[#2e237f] text-white rounded-lg h-[38px] w-[250px] flex items-center justify-center font-medium"
                          onClick={() => {
                            let nextId = 1;
                            if (addressDetails.length > 0) {
                              const maxId = Math.max(
                                ...addressDetails.map(
                                  (addr) => parseInt(addr.optnAddressId) || 0,
                                ),
                              );
                              nextId = maxId + 1;
                            }
                            // Set tentative optnAddressId in form immediately for use in CreateOrderModal
                            setForm((prev) => ({
                              ...prev,
                              pickAddressId: nextId.toString(),
                              returnAddressId: nextId.toString(),
                            }));
                            setModalColumnData({
                              optnAddressId: nextId.toString(),
                            });
                            setShowCustomAddressModal(true);
                            setExpectNewAddress(true);
                          }}
                        >
                          Add Address
                        </button>
                      )}
                    </div>
                    {/* ✅ Pickup Address Card */}
                    {hasPickup && (
                      <div className="col-span-1">
                        <label className="w-full">
                          <span>Pickup Address</span>
                          <div className="flex flex-col divide-y divide-indigo-slate overflow-hidden rounded-lg border border-slate-300 mt-1.5 max-w-[450px]">
                            <div className="flex cursor-pointer items-center justify-between text-medium-150 px-4 py-2 font-normal sm:px-5">
                              {form?.useConsignorForPickup
                                ? form.consignorName || "Consignor"
                                : selectedPickupAddress?.addressTitle ||
                                  "Not specified"}
                            </div>
                            <div className="flex cursor-pointer items-center justify-between px-4 py-2 font-medium sm:px-5">
                              {form?.useConsignorForPickup
                                ? form.consignorAddress1 ||
                                  "Address not specified"
                                : selectedPickupAddress?.fullAddress ||
                                  "Address not specified"}
                            </div>
                            <div className="flex cursor-pointer items-center justify-between px-4 py-2 font-normal sm:px-5">
                              {form?.useConsignorForPickup
                                ? `${form.consignorCity || "Not specified"}, ${
                                    form.consignorState || "Not specified"
                                  }, ${
                                    form.consignorPincode || "Not specified"
                                  }`
                                : `${
                                    selectedPickupAddress?.city ||
                                    "Not specified"
                                  }, ${
                                    selectedPickupAddress?.state ||
                                    "Not specified"
                                  }, ${
                                    selectedPickupAddress?.pinCode ||
                                    "Not specified"
                                  }`}
                            </div>
                            <div className="flex gap-2 cursor-pointer items-center px-4 py-2 font-normal sm:px-5">
                              <PhoneIcon sx={{ width: 18, height: 18 }} />{" "}
                              {form?.useConsignorForPickup
                                ? form.consignorMobile ||
                                  form.consignorPhone ||
                                  "Not specified"
                                : selectedPickupAddress?.phone ||
                                  "Not specified"}
                            </div>
                          </div>
                        </label>
                      </div>
                    )}
                    {/* ✅ Return Address Card */}
                    {((hasPickup && displayReturnAddress) ||
                      (hasPickup && form?.useConsignorForReturn)) && (
                      <div className="col-span-1">
                        <label className="w-full">
                          <span>Return Address</span>
                          <div className="flex flex-col divide-y divide-indigo-slate overflow-hidden rounded-lg border border-slate-300 mt-1.5 max-w-[450px]">
                            <div className="flex cursor-pointer items-center justify-between text-medium-150 px-4 py-2 font-normal sm:px-5">
                              {form?.useConsignorForReturn
                                ? form.consignorName || "Consignor"
                                : displayReturnAddress?.addressTitle ||
                                  "Not specified"}
                            </div>
                            <div className="flex cursor-pointer items-center justify-between px-4 py-2 font-medium sm:px-5">
                              {form?.useConsignorForReturn
                                ? form.consignorAddress1 ||
                                  "Address not specified"
                                : displayReturnAddress?.fullAddress ||
                                  "Address not specified"}
                            </div>
                            <div className="flex cursor-pointer items-center justify-between px-4 py-2 font-normal sm:px-5">
                              {form?.useConsignorForReturn
                                ? `${form.consignorCity || "Not specified"}, ${
                                    form.consignorState || "Not specified"
                                  }, ${
                                    form.consignorPincode || "Not specified"
                                  }`
                                : `${
                                    displayReturnAddress?.city ||
                                    "Not specified"
                                  }, ${
                                    displayReturnAddress?.state ||
                                    "Not specified"
                                  }, ${
                                    displayReturnAddress?.pinCode ||
                                    "Not specified"
                                  }`}
                            </div>
                            <div className="flex gap-2 cursor-pointer items-center px-4 py-2 font-normal sm:px-5">
                              <PhoneIcon sx={{ width: 18, height: 18 }} />{" "}
                              {form?.useConsignorForReturn
                                ? form.consignorMobile ||
                                  form.consignorPhone ||
                                  "Not specified"
                                : displayReturnAddress?.phone ||
                                  "Not specified"}
                            </div>
                          </div>
                        </label>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
            {/* ----------------------------------Product Section ------------------------------------- */}
            {products.map((prod, index) => (
              <div
                key={index}
                className={styles["product-container-style"]}
                style={{ backgroundColor: "#f9fafb" }}
              >
                <div className="flex items-center mb-4 space-x-3">
                  <button
                    type="button"
                    onClick={() => {
                      setSections((prev) => {
                        const newProductSections = [
                          ...(prev.productSections ||
                            Array(products.length).fill(false)),
                        ];
                        newProductSections[index] = !newProductSections[index];
                        return { ...prev, productSections: newProductSections };
                      });
                    }}
                    className="text-gray-600 hover:text-gray-800 focus:outline-none"
                  >
                    {sections?.productSections &&
                    sections.productSections[index] ? (
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <line x1="5" y1="12" x2="19" y2="12" />
                      </svg>
                    ) : (
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <line x1="12" y1="5" x2="12" y2="19" />
                        <line x1="5" y1="12" x2="19" y2="12" />
                      </svg>
                    )}
                  </button>
                  <h5 className="modal-title main-title">
                    Product {index + 1}
                  </h5>
                </div>
                {sections?.productSections &&
                  sections.productSections[index] && (
                    <>
                      {/* Top Row - 3-column grid */}
                      <div className={styles["product-grid-3"]}>
                        {/* Product Name */}
                        <div className={styles["product-field"]}>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Product Name{" "}
                            <span className={styles["required-asterisk"]}>
                              *
                            </span>
                          </label>
                          <div className="relative w-full">
                            <span className="absolute left-3 top-[43%] -translate-y-1/2 text-gray-400">
                              <FaProductHunt className="text-gray" />
                            </span>
                            <input
                              className={`${styles["input-style"]} !rounded-lg !pl-10 !pr-4 !py-2 h-[38px]`}
                              name="productName"
                              value={prod.productName}
                              onChange={(e) => handleProductChange(index, e)}
                              placeholder="Enter product name"
                              maxLength={50}
                              onBlur={(e) => handleProductBlur(index, e)}
                              disabled={isReadOnly}
                            />
                          </div>
                          {productErrors[index]?.productName && (
                            <div className={styles["error-style"]}>
                              {productErrors[index].productName}
                            </div>
                          )}
                        </div>
                        {/* Product Quantity */}
                        <div className={styles["product-field"]}>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Product Quantity{" "}
                            <span className={styles["required-asterisk"]}>
                              *
                            </span>
                          </label>
                          <div className="relative w-full">
                            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                              <MdProductionQuantityLimits className="text-gray" />
                            </span>
                            <input
                              className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-right placeholder:text-left"
                              name="productQuantity"
                              value={prod.productQuantity}
                              onChange={(e) => handleProductChange(index, e)}
                              onBlur={(e) => handleProductBlur(index, e)}
                              placeholder="Enter quantity"
                              disabled={isReadOnly}
                            />
                          </div>
                          {productErrors[index]?.productQuantity && (
                            <div className={styles["error-style"]}>
                              {productErrors[index].productQuantity}
                            </div>
                          )}
                        </div>
                        {/* Product Value */}
                        <div className={styles["product-field"]}>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Product Value{" "}
                            <span className={styles["required-asterisk"]}>
                              *
                            </span>
                          </label>
                          <div className="relative w-full">
                            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                              <TagIcon
                                className="text-gray"
                                sx={{ width: 20, height: 20 }}
                              />
                            </span>
                            <input
                              className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-right placeholder:text-left"
                              name="productValue"
                              value={prod.productValue}
                              onChange={(e) => {
                                const input = e.target.value;
                                if (/^\d*\.?\d{0,2}$/.test(input)) {
                                  const updatedProducts = [...products];
                                  updatedProducts[index][e.target.name] = input;
                                  setProducts(updatedProducts);
                                  const updatedProductErrors = [
                                    ...productErrors,
                                  ];
                                  updatedProductErrors[index] = {
                                    ...updatedProductErrors[index],
                                    [e.target.name]: validateProductField(
                                      e.target.name,
                                      input,
                                    ),
                                  };
                                  setProductErrors(updatedProductErrors);
                                }
                              }}
                              onBlur={(e) => handleProductBlur(index, e)}
                              placeholder="Enter value"
                              disabled={isReadOnly}
                            />
                          </div>
                          {productErrors[index]?.productValue && (
                            <div className={styles["error-style"]}>
                              {productErrors[index].productValue}
                            </div>
                          )}
                        </div>
                      </div>
                      {/* Middle Row - 4-column grid */}
                      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                        {/* Product Category */}
                        <div className="flex flex-col w-[250px]">
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Product Category{" "}
                            <span className={styles["required-asterisk"]}>
                              *
                            </span>
                          </label>
                          <div className="relative w-full">
                            <span className="absolute left-3 top-[43%] -translate-y-1/2 text-gray-400">
                              <FaList className="text-gray" />
                            </span>
                            <input
                              className={`${styles["input-style"]} !rounded-lg !pl-10 !pr-4 !py-2 h-[38px]`}
                              name="productCategory"
                              value={prod.productCategory}
                              onChange={(e) => handleProductChange(index, e)}
                              placeholder="Enter category"
                              onBlur={(e) => handleProductBlur(index, e)}
                              disabled={isReadOnly}
                            />
                          </div>
                          {productErrors[index]?.productCategory && (
                            <div className={styles["error-style"]}>
                              {productErrors[index].productCategory}
                            </div>
                          )}
                        </div>
                        {/* Product Taxper */}
                        <div className="flex flex-col w-[250px]">
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Product Taxper
                          </label>
                          <div className="relative w-full">
                            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                              <TagIcon
                                className="text-gray"
                                sx={{ width: 20, height: 20 }}
                              />
                            </span>
                            <input
                              className="w-full pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-right placeholder:text-left"
                              name="productTaxper"
                              value={prod.productTaxper}
                              onChange={(e) => handleProductChange(index, e)}
                              onBlur={(e) => handleProductBlur(index, e)}
                              placeholder="Enter tax %"
                              disabled={isReadOnly}
                            />
                          </div>
                          {productErrors[index]?.productTaxper && (
                            <div className={styles["error-style"]}>
                              {productErrors[index].productTaxper}
                            </div>
                          )}
                        </div>
                        <div className="flex flex-col w-[250px]">
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Product SKU
                          </label>
                          <div className="relative w-full">
                            <span className="absolute left-3 top-[43%] -translate-y-1/2 text-gray-400">
                              <IoMdPaper className="text-gray" />
                            </span>
                            <input
                              className={`${styles["input-style"]} !rounded-lg !pl-10 !pr-4 !py-2 h-[38px]`}
                              name="productSku"
                              value={prod.productSku}
                              onChange={(e) => handleProductChange(index, e)}
                              placeholder="Enter SKU"
                              onBlur={(e) => handleProductBlur(index, e)}
                              disabled={isReadOnly}
                            />
                          </div>
                          {productErrors[index]?.productSku && (
                            <div className={styles["error-style"]}>
                              {productErrors[index].productSku}
                            </div>
                          )}
                        </div>
                        <div className="flex flex-col w-[250px]">
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Product HSNSAC
                          </label>
                          <div className="relative w-full">
                            <span className="absolute left-3 top-[43%] -translate-y-1/2 text-gray-400">
                              <TagIcon
                                className="text-gray"
                                sx={{ width: 20, height: 20 }}
                              />
                            </span>
                            <input
                              className={`${styles["input-style"]} !rounded-lg !pl-10 !pr-4 !py-2 h-[38px]`}
                              name="productHsnsac"
                              value={prod.productHsnsac}
                              onChange={(e) => handleProductChange(index, e)}
                              placeholder="Enter HSNSAC"
                              onBlur={(e) => handleProductBlur(index, e)}
                              disabled={isReadOnly}
                            />
                          </div>
                          {productErrors[index]?.productHsnsac && (
                            <div className={styles["error-style"]}>
                              {productErrors[index].productHsnsac}
                            </div>
                          )}
                        </div>
                      </div>
                      {/* Full-width textarea for Product Description */}
                      <div className={styles["product-description-section"]}>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Product Description
                        </label>
                        <div className="relative w-full">
                          <span className="absolute left-3 top-[25%] -translate-y-1/2 text-gray-400">
                            <TbFileDescription className="text-gray" />
                          </span>
                          <textarea
                            className={`${styles["input-style"]} ${styles["description-textarea"]} !rounded-lg !pl-10 !pr-4 !py-2`}
                            name="productDescription"
                            value={prod.productDescription}
                            onChange={(e) => handleProductChange(index, e)}
                            placeholder="Enter description"
                            onBlur={(e) => handleProductBlur(index, e)}
                            disabled={isReadOnly}
                          />
                        </div>
                        {productErrors[index]?.productDescription && (
                          <div className={styles["error-style"]}>
                            {productErrors[index].productDescription}
                          </div>
                        )}
                      </div>
                      {/* Remove product button */}
                      {products.length > 1 && (
                        <button
                          type="button"
                          className={styles["remove-product-btn-style"]}
                          onClick={() => removeProduct(index)}
                          title="Remove Product"
                          disabled={isReadOnly}
                        >
                          <FaTrash />
                        </button>
                      )}
                    </>
                  )}
              </div>
            ))}
            {/* ==== CHECKBOX BLOCK ==== */}
            <div className="px-4 mt-6">
              <label className="flex items-center gap-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={form.govtApprovedGoods || false}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,
                      govtApprovedGoods: e.target.checked,
                    }))
                  }
                  disabled={isReadOnly}
                  className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <span className="text-sm text-gray-700 leading-tight">
                  I confirm that the goods comply with all government
                  regulations. <span className="text-red-500">*</span>
                </span>
              </label>
              {errors.govtApprovedGoods && (
                <p className="text-sm text-red-500 mt-1 ml-7">
                  {errors.govtApprovedGoods}
                </p>
              )}
            </div>
            {/* ==== END OF CHECKBOX BLOCK ==== */}
            <div
              className={`flex ${
                action === "cancelOrder" || action === "view"
                  ? "justify-end"
                  : "justify-between"
              } items-center mt-6 px-4`}
            >
              {action !== "view" && action !== "cancelOrder" && (
                <button
                  type="button"
                  className={`${styles["add-product-btn-style"]} !h-[42px] !rounded-[10px]`}
                  onClick={addProduct}
                  disabled={isReadOnly}
                >
                  + Add Product
                </button>
              )}
              <div className="flex gap-4">
                <button
                  type="button"
                  className="btn btn-back !w-[133px] !justify-center !h-[42px] !rounded-[10px]"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                {!isReadOnly && (action === "add" || action === "modify") && (
                  <button
                    type="button"
                    className="btn btn-submit !w-[133px] !justify-center !h-[42px] !rounded-[10px]"
                    onClick={handleSubmit}
                    disabled={loading || pincodeLoading}
                  >
                    {loading
                      ? "Submitting..."
                      : action === "modify"
                      ? "Update"
                      : "Submit"}
                  </button>
                )}

                {action === "cancelOrder" && (
                  <button
                    type="button"
                    className="btn btn-submit !w-[143px] !justify-center !h-[42px] !rounded-[10px]"
                    onClick={() => setShowCancelModal(true)}
                    disabled={loading || pincodeLoading}
                  >
                    {loading ? "Submitting..." : "Cancel Order"}
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* Removed OrderConfirmationReceipt rendering */}
      <AddPickupAddressModal
        show={showCustomAddressModal}
        handleClose={() => {
          setShowCustomAddressModal(false);
          setModalColumnData({});
        }}
        callApi={() => fetchAddressDetails()}
        editData={{}}
        action="add"
        columnData={modalColumnData}
      />

      {/* ---------- Charges Confirmation Modal ---------- */}
      <ChargesConfirmationModal
        show={showChargesModal}
        onClose={() => {
          setShowChargesModal(false);
          setChargesData(null);
        }}
        chargesData={chargesData}
        codCharges={codCharges}
        loading={chargesLoading}
        onConfirm={() => {
          // When user confirms, call the create-order function
          submitCreateOrder();
        }}
      />

      {/* ---------- Cancel Order Modal ---------- */}
      {showCancelModal && (
        <CancelOrderModal
          show={showCancelModal}
          handleClose={() => setShowCancelModal(false)}
          handleMainModalClose={() => handleClose()}
          columnData={columnData}
          callApi={() => refreshTable()}
        />
      )}
    </>,
    document.body,
  );
};
export default CreateOrderModal;
